"use strict";

var ENGINE = ENGINE || {};
ENGINE.SimulatorCommon = {
  init: function () {
    // ホバー時にクラス付与
    $('.js_hover').hover(function () {
      $('body').addClass('is_hover');
    }, function () {
      $('body').removeClass('is_hover');
    });
  },

	/**
	 * CSVファイルの解析
	 *
	 */
	parseCSV: function(csv) {
		let tmp=[];

		csv=csv.replace(/("[^"]*")+/g, function(match) {
			tmp.push(match.slice(1,-1).replace(/""/g,'"'));return '[TMP]';
		});

		return csv.split("\n").map(function(row) {
			return row.split(',').map(function(val) {
				return val==='[TMP]'?tmp.shift():val;
			});
		});
	},
	/**
	 * CSV形式のデータをJSON形式に変換
	 * ※製品マスタで定義されたCSVファイル
	 *
	 */
	parseCSV2JSON: function(data) {
		var products = [];

		// タイトル行の取得
		var title;
		var titles = data[2];

		// 3行目からデータ行
		for(var row_idx=3, row_max=data.length; row_idx<row_max; row_idx++) {
			var product = {};
			for(var col_idx=0, col_max=data[row_idx].length; col_idx<col_max; col_idx++) {
				title = (titles[col_idx] + '').trim();
				product[title] = (data[row_idx][col_idx] + '').trim();
			}
			products.push(product);
		}

		return products;
	},
	/**
	 * ファイル読み込み
	 *
	 */
	load: function(url, callback_func, error_func, progress_func) {

		var _this = this;
		var xhr = new XMLHttpRequest();

		progress_func = ( progress_func && (typeof progress_func == 'function') )?progress_func:console.log;

		// Handlerの登録.
		xhr.onreadystatechange = function() {
			switch ( xhr.readyState ) {
				case 0:
					// 未初期化状態.
					progress_func(xhr.readyState);
					break;
				case 1: // データ送信中.
					progress_func(xhr.readyState);
					break;
				case 2: // 応答待ち.
					progress_func(xhr.readyState);
					break;
				case 3: // データ受信中.
					progress_func(xhr.readyState, xhr.responseText.length);
					break;
				case 4: // データ受信完了.
					if( xhr.status == 200 || xhr.status == 304 ) {
						var data = xhr.responseText; // responseXML もあり
						progress_func(xhr.readyState);
						callback_func(data);
					} else {
						progress_func(xhr.readyState);
						error_func(xhr.statusText);
					}
					break;
			}
		};

		xhr.open("get", url, false);
		xhr.send(null);
		xhr.abort(); // 再利用する際にも abort() しないと再利用できない
	},
	/**
	 * 金額表示フォーマット変更
	 *
	 */
	priceFormat: function(num, options) {
		var cnv = num + '';
		// 不要な文字を削除
		cnv = cnv.replace( /[^0-9\.]/g, '');

		// 数値形式に変換
		cnv = Number(cnv);

		// 小数点表示ありの場合
		var digit = (options && options['price_decimal_point_digit'])?options['price_decimal_point_digit']:0;
		cnv = cnv.toFixed(digit);
		// 3桁区切り文字の取得
		var token = (options && options['price_token'])?options['price_token']:',';
		// 金額のフォーマット変換
		var price = String(cnv).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1'+token);
		// 金額単位の取得
		var price_unit = (options && options['price_unit'])?options['price_unit']:'';
		// 金額単位の表示位置の取得
		var price_unit_pos = (options && options['price_unit_pos'])?options['price_unit_pos']:0;

		// 単位の設定
		if (price_unit) {
			if (price_unit_pos == 2) {
				price = price + ' ' + price_unit;
			} else {
				price = price_unit + ' ' + price;
			}
		}

		return price;
	},
	/**
	 *
	 *
	 */
	zeroPadding: function(num, len){
		return ('0000000000' + num).slice(-len);
	},
	/**
	 * ファイル読み込み
	 *
	 */
	stageFit: function() {
		var $win   = $(window);
		var $stage = $('.js-stage');
		var _STAGE_H = $stage.height();
		var _STAGE_W = $stage.width();
		var _RATIO = _STAGE_W / _STAGE_H;

		// $win.off('resize', )
		$win.off('resize.stagefit');
		$win.on('resize.stagefit', _init);

		function _init() {
			$stage.each(function() {
				_fit($(this));
			});
		}

		function _fit($target) {
// console.log('resize');
// console.log('resize : ' + $stage.length);
			_STAGE_H = $target.height();
			_STAGE_W = $target.width();

			if ( (_STAGE_H == 0) || (_STAGE_W == 0) ) {
				return;
			}

			_RATIO = _STAGE_W / _STAGE_H;

// console.log(_STAGE_H + ' : ' + _STAGE_W + ' => ' + _RATIO);

			if ( (_RATIO > 0) && (_RATIO < 0.5) ) {
				$target.addClass('is-tatenaga-s');
				$target.removeClass('is-tatenaga');
				$target.removeClass('is-yokonaga');
				$target.removeClass('is-yokonaga-s');
			} else if ( (_RATIO > 0) && (_RATIO < 1) ) {
				$target.removeClass('is-tatenaga-s');
				$target.addClass('is-tatenaga');
				$target.removeClass('is-yokonaga');
				$target.removeClass('is-yokonaga-s');
			} else if (_RATIO > 1.75) {
				$target.removeClass('is-tatenaga-s');
				$target.removeClass('is-tatenaga');
				$target.removeClass('is-yokonaga');
				$target.addClass('is-yokonaga-s');

			} else if (_RATIO > 2.5) {
				$target.removeClass('is-tatenaga-s');
				$target.removeClass('is-tatenaga');
				$target.removeClass('is-yokonaga-s');
				$target.addClass('is-yokonaga');
			} else {
				$target.removeClass('is-tatenaga-s');
				$target.removeClass('is-tatenaga');
				$target.removeClass('is-yokonaga');
				$target.removeClass('is-yokonaga-s');
			}
		}

		_init();
	},

	/**
	 *
	 *
	 */
	getURLParameter() {

		var qstr = window.location.href;
		var regex = /[?&]([^=#]+)=([^&#]*)/g;
		var result = {};
		var match;

		while(match = regex.exec(qstr)){
			result[match[1]] = match[2];
		}
		return result;
	},
};
var ENGINE = ENGINE || {};
ENGINE.Simulator = ENGINE.Simulator || {};


ENGINE.Simulator = {
	// 外部データ（CSV、JSON）のURLを指定
	data_url: {
		faucet_csv:   '../assets/data/faucet.csv',
		lavatory_csv: '../assets/data/lavatory.csv',
		relation_csv: '../assets/data/faucet-lavatory-relation.csv',
		setting_json: '../assets/data/settings.json',
		message_json: '../assets/data/message.json',
	},
	// 各種設定
	settings: {
		'faucet_image'   : '../assets/images/products/faucet/',
		'lavatory_image' : '../assets/images/products/lavatory/',
		'icon_image'     : '../assets/images/common/icon/',
		'common_image'   : '../assets/images/products/common/',
		'cookie_id'      : 'faucet-lavatory-favorite',
		'cookie_expired' : 30,
	},
	// 外部データ（CSV、JSON）のURLを指定
	vars: {
		loaded: 0,
		faucet_list: null,         // 全faucet製品のリスト（通常配列）
		faucet_master: {},         // 全faucet製品の品番をキーとする連想配列
		faucet_list4series: {},    // seriesごとに分類した製品リスト
		faucet_list4shape:  {},    // shapeごとに分類した製品リスト
		faucet_list4colour: {},    // colourごとに分類した製品リスト
		lavatory_list: null,      // 全lavatory製品のリスト（通常配列）
		lavatory_master: {},      // 全lavatory製品の品番をキーとする連想配列
		lavatory_list4shape:  {}, // shapeごとに分類した製品リスト
		faucet_relation_list: null,
		lavatory_relation_list: null,
	},
	// 画面遷移時に呼び出す関数
	func: {
		// 画面遷移時の関数の定義
		// Faucet / Series選択画面
		'move-faucet-series' : false,
		// Faucet / Shape選択画面
		'move-faucet-shape' : false,
		// Faucet / Colour選択画面
		'move-faucet-colour' : false,
		// Faucet / 製品一覧画面
		'move-faucet-product' : false,
		// Faucet / 色選択画面
		'move-faucet-select-colour' : false,
		// lavatory / Shape選択
		'move-lavatory-shape' : false,
		// lavatory / 製品一覧画面
		'move-lavatory-product' : false,
		// 結果画面
		'move-result' : false,
		// 前の画面へ戻る
		'move-back' : false,
		// TOPページ
		'move-top' : false,
		// 保存リスト
		'move-saved' : false,
		// 比較
		'move-compare' : false,

	  // 処理実行用の関数の登録
		// 色選択
		'action-select-faucet-colour' : false,
		// 色選択（結果画面）
		'action-swap-faucet-colour-results' : false,
		// Add Plan
		'action-add-favorite' : false,
		// Share
		'action-open-share' : false,
		// delete favorite (saved)
		'action-delete-favorite-saved' : false,
		// hide favorite (compare)
		'action-hide-favorite-compare' : false,
	},
	// 画面リスト（仮面IDをキー、jQueryオブジェクトを値にした連想配列
	panel_list: null,
	// 画面遷移履歴を格納した配列
	panel_history_list: [],
	// 現在表示中のパネルID
	active_panel_id: 'top',
	// 選択した値
	condition: {
		'faucet-series'    : null,
		'faucet-shape'     : null,
		'faucet-colour'    : null,
		'faucet-product'   : null,
		'lavatory-shape'   : null,
		'lavatory-product' : null,
	},
	// ステップフロー情報格納用
	flow_nav: {
		'container': false,
		'all-items': false,
		'items': false,
		'links': false,
		'first-step': 'faucet-series'
	},
	// ステップフロー表示順（シミュレーション開始画面により変わる）
	flow_list : {
			// Faucet - Series からシミュレーション開始した場合
			'faucet-series' : [
			 {'id': 'faucet-series',        'show': true}
			,{'id': 'faucet-product',       'show': true}
			,{'id': 'faucet-select-colour', 'show': true}
			,{'id': 'lavatory-shape',      'show': true}
			,{'id': 'lavatory-product',    'show': true}
			,{'id': 'faucet-shape',         'show': false}
			,{'id': 'faucet-colour',        'show': false}
			,{'id': 'result',               'show': true}
		],
		// Faucet - Shape からシミュレーション開始した場合
		'faucet-shape' : [
			 {'id': 'faucet-shape',         'show': true}
			,{'id': 'faucet-series',        'show': true}
			,{'id': 'faucet-product',       'show': true}
			,{'id': 'faucet-select-colour', 'show': true}
			,{'id': 'lavatory-shape',      'show': true}
			,{'id': 'lavatory-product',    'show': true}
			,{'id': 'faucet-colour',        'show': false}
			,{'id': 'result',               'show': true}
		],
		// Faucet - Colour からシミュレーション開始した場合
		'faucet-colour' : [
			 {'id': 'faucet-colour',        'show': true}
			,{'id': 'faucet-series',        'show': true}
			,{'id': 'faucet-product',       'show': true}
			,{'id': 'lavatory-shape',      'show': true}
			,{'id': 'lavatory-product',    'show': true}
			,{'id': 'faucet-shape',         'show': false}
			,{'id': 'faucet-select-colour', 'show': false}
			,{'id': 'result',               'show': true}
		],
	// Lavatory - Shape からシミュレーション開始した場合
		'lavatory-shape' : [
			 {'id': 'lavatory-shape',      'show': true}
			,{'id': 'lavatory-product',    'show': true}
			,{'id': 'faucet-series',        'show': true}
			,{'id': 'faucet-product',       'show': true}
			,{'id': 'faucet-select-colour', 'show': true}
			,{'id': 'faucet-shape',         'show': false}
			,{'id': 'faucet-colour',        'show': false}
			,{'id': 'result',               'show': true}
		]
	},
	// 各種メッセージ
	messages: {
	},

	//////////////////////////////////////////////////////////////////
	// 各種処理
	//////////////////////////////////////////////////////////////////
	init: function() {

// console.log(ENGINE.SimulatorCommon);

		// 各種関数のセットアップ
		this.initFunction();

		// 各種データファイルの読み込み
		this.loader([
			// 設定データの読み込み
			{
				url: this.data_url.setting_json,
				callback: this.initSettings,
			},
			// メッセージデータの読み込み
			{
				url: this.data_url.message_json,
				callback: this.initMassages,
			},
			// Faucetデータの読み込み
			{
				url: this.data_url.faucet_csv,
				callback: this.initFaucet,

			},
			// Lavatoryデータの読み込み
			{
				url: this.data_url.lavatory_csv,
				callback: this.initLavatory,
			},
			{
				url: this.data_url.relation_csv,
				callback: this.initRelation,
			},
		]);

	},
	/**
	 * 各種データの読み込み
	 * ※読み込み完了後、引数で渡されたCallback関数を呼び出し
	 *
	 */
	loader: function(list) {
		this.vars.loaded = list.length;
		for(var i=0, max=list.length; i<max; i++) {
			ENGINE.SimulatorCommon.load(
				list[i].url,
				list[i].callback,
				this.error,
				this.progress,
			);
		}
	},
	/**
	 *
	 *
	 */
	error: function(message) {
		// console.log(message);
	},
	/**
	 *
	 *
	 */
	progress: function(status) {
		// console.log(status);
	},
	/**
	 * 各種関数のセットアップ
	 *
	 */
	initFunction: function() {

		// 画面遷移時の関数の定義
		// Faucet / Series選択画面
		this.func['move-faucet-series'] = ENGINE.Simulator.moveFaucetSeries;
		// Faucet / Shape選択画面
		this.func['move-faucet-shape'] =  ENGINE.Simulator.moveFaucetShape;
		// Faucet / Colour選択画面
		this.func['move-faucet-colour'] = ENGINE.Simulator.moveFaucetColour;
		// Faucet / 製品一覧画面
		this.func['move-faucet-product'] = ENGINE.Simulator.moveFaucetProduct;
		// Faucet / 色選択画面
		this.func['move-faucet-select-colour'] = ENGINE.Simulator.moveFaucetSelectColour;
		// lavatory / Shape選択
		this.func['move-lavatory-shape'] = ENGINE.Simulator.moveLavatoryShape;
		// lavatory / 製品一覧画面
		this.func['move-lavatory-product'] = ENGINE.Simulator.moveLavatoryProduct;
		// 結果画面
		this.func['move-result'] = ENGINE.Simulator.moveResult;
		// 前の画面へ戻る
		this.func['move-back'] = ENGINE.Simulator.moveBack;
		// TOPページ
		this.func['move-top'] = ENGINE.Simulator.moveTop;
		// 保存リスト
		this.func['move-saved'] = ENGINE.Simulator.moveSaved;
		// 比較
		this.func['move-compare'] = ENGINE.Simulator.moveCompare;

	  // 処理実行用の関数の登録
		// 色選択
		this.func['action-select-faucet-colour'] = ENGINE.Simulator.selectFaucetColour;
		// 色選択（結果画面）
		this.func['action-swap-faucet-colour-results'] = ENGINE.Simulator.swapFaucetColour4Results;
		// Add Plan
		this.func['action-add-favorite'] = ENGINE.Simulator.addFavorite;
		// Share（結果画面）
		this.func['action-open-share'] = ENGINE.Simulator.openShare;
		// Share（お気に入り）
		this.func['action-open-share-saved'] = ENGINE.Simulator.openShare4Saved;


		// swap favorite (saved)
		// this.func['action-swap-favorite-saved'] = ENGINE.Simulator.swapFavoriteSaved;
		// delete favorite (saved)
		this.func['action-delete-favorite-saved'] = ENGINE.Simulator.deleteFavoriteSaved;

		// hide favorite (compare)
		this.func['action-hide-favorite-compare'] = ENGINE.Simulator.hideFavoriteCompare;
		// swap favorite (compare)
		this.func['action-swap-favorite-compare'] = ENGINE.Simulator.swapFavoriteCompare;
		// show all favorite (compare)
		this.func['action-show-favorite-compare-all'] = ENGINE.Simulator.showFavoriteCompareAll;
		// click change form favorite
		this.func['action-swap-favorite-product'] = ENGINE.Simulator.swapFavoriteProduct;

		// DOWNLOAD PDF（結果画面）
		this.func['action-download-pdf'] = ENGINE.Simulator.downloadPDF;
		// DOWNLOAD PDF（お気に入り）
		this.func['action-download-pdf-saved'] = ENGINE.Simulator.downloadPDF4Saved;
		// Share URL
		this.func['action-copy-result-url'] = ENGINE.Simulator.copyResultURL;
		// Copy URL
		this.func['action-share-result-url'] = ENGINE.Simulator.shareResultURL;
	},
	/**
	 * 設定データファイル読み込み後のCallback関数
	 * 処理終了後、各callback関数共通でsetup()を呼び出す
	 *
	 */
	initSettings: function(data) {
// console.log('initSettings() - start.');
// console.log(data);
		// 取得したテキストデータをJSON形式に変換
		var options = JSON.parse(data);
		ENGINE.Simulator.settings = Object.assign(ENGINE.Simulator.settings, options);
// console.log('initSettings() : get settings');
// console.log(ENGINE.Simulator.settings);

		// 初期処理の呼び出し
		ENGINE.Simulator.setup();
// console.log('initSettings() - end.');
	},
	/**
	 * メッセージデータファイル読み込み後のCallback関数
	 * 処理終了後、各callback関数共通でsetup()を呼び出す
	 *
	 */
	initMassages: function(data) {
// console.log('initMassages() - start.');
		// 取得したテキストデータをJSON形式に変換
		var options = JSON.parse(data);
		ENGINE.Simulator.messages = Object.assign(ENGINE.Simulator.messages, options);

// console.log('initMassages() : get messages');
// console.log(ENGINE.Simulator.messages);
		// 初期処理の呼び出し
		ENGINE.Simulator.setup();
// console.log('initMassages() - end.');
	},
	/**
	 * Faucet 製品データの取得（CSVデータ→連想配列へ）
	 * 製品データファイル読み込み後のCallback関数
	 * 処理終了後、各callback関数共通でsetup()を呼び出す
	 *
	 */
	initFaucet: function(data) {
// console.log('initFaucet() - start.');

		// 取得したテキストデータをCSV形式に変換
		data = ENGINE.SimulatorCommon.parseCSV(data);
		// CSV形式のデータをJSON形式のデータに変換
		ENGINE.Simulator.vars.faucet_list = ENGINE.SimulatorCommon.parseCSV2JSON(data);

		var product_id, series, shape, colour, colour_id;
		var colour_list = ENGINE.Simulator.settings['faucet_colour'];
		for(var i=0,max=ENGINE.Simulator.vars.faucet_list.length; i<max; i++) {

			// 製品品番をキーにした連想配列の生成
			product_id = ENGINE.Simulator.vars.faucet_list[i]['PRODUCT_ID'];
			ENGINE.Simulator.vars.faucet_master[product_id] = ENGINE.Simulator.vars.faucet_list[i];

			// seriesごとに分類した製品リストの生成
			series = ENGINE.Simulator.vars.faucet_list[i]['SERIES'];
			if (ENGINE.Simulator.vars.faucet_list4series[series]) {
				ENGINE.Simulator.vars.faucet_list4series[series].push(ENGINE.Simulator.vars.faucet_list[i]);
			} else {
				ENGINE.Simulator.vars.faucet_list4series[series] = [];
				ENGINE.Simulator.vars.faucet_list4series[series].push(ENGINE.Simulator.vars.faucet_list[i]);
			}

			// shapeごとに分類した製品リスト
			shape  = ENGINE.Simulator.vars.faucet_list[i]['SHAPE'];
			if (ENGINE.Simulator.vars.faucet_list4shape[shape]) {
				ENGINE.Simulator.vars.faucet_list4shape[shape].push(ENGINE.Simulator.vars.faucet_list[i]);
			} else {
				ENGINE.Simulator.vars.faucet_list4shape[shape] = [];
				ENGINE.Simulator.vars.faucet_list4shape[shape].push(ENGINE.Simulator.vars.faucet_list[i]);
			}

			// colourごとに分類した製品リスト
			for(var colour_cat in colour_list) {
				for(var colour in colour_list[colour_cat]) {
					colour_id = 'COLOUR_' + colour;
					if (ENGINE.Simulator.vars.faucet_list[i][colour_id] == 1) {
						if (ENGINE.Simulator.vars.faucet_list4colour[colour]) {
							ENGINE.Simulator.vars.faucet_list4colour[colour].push(ENGINE.Simulator.vars.faucet_list[i]);
						} else {
							ENGINE.Simulator.vars.faucet_list4colour[colour] = [];
							ENGINE.Simulator.vars.faucet_list4colour[colour].push(ENGINE.Simulator.vars.faucet_list[i]);
						}
					}
				}
			}
		}

// console.log('initFaucet() : show faucet_list');
// console.log(ENGINE.Simulator.vars.faucet_list);
// console.log('initFaucet() : show faucet_master');
// console.log(ENGINE.Simulator.vars.faucet_master);
// console.log('initFaucet() : show faucet_list4series');
// console.log(ENGINE.Simulator.vars.faucet_list4series);
// console.log('initFaucet() : show faucet_list4shape');
// console.log(ENGINE.Simulator.vars.faucet_list4shape);
// console.log('initFaucet() : show faucet_list4colour');
// console.log(ENGINE.Simulator.vars.faucet_list4colour);

		// 初期処理の呼び出し
		ENGINE.Simulator.setup();

// console.log('initFaucet() - end.');
	},
	/**
	 * Lavatory 製品データの取得（CSVデータ→連想配列へ）
	 * 製品データファイル読み込み後のCallback関数
	 * 処理終了後、各callback関数共通でsetup()を呼び出す
	 *
	 */
	initLavatory: function(data) {
// console.log('initLavatory() - start.');
		// 取得したテキストデータをCSV形式に変換
		data = ENGINE.SimulatorCommon.parseCSV(data);
		// CSV形式のデータをJSON形式のデータに変換
		ENGINE.Simulator.vars.lavatory_list = ENGINE.SimulatorCommon.parseCSV2JSON(data);

		var product_id, shape;
		for(var i=0,max=ENGINE.Simulator.vars.lavatory_list.length; i<max; i++) {
			// seriesごとに分類した製品リストの生成
			product_id = ENGINE.Simulator.vars.lavatory_list[i]['PRODUCT_ID'];
			ENGINE.Simulator.vars.lavatory_master[product_id] = ENGINE.Simulator.vars.lavatory_list[i];

			// shapeごとに分類した製品リスト
			shape  = ENGINE.Simulator.vars.lavatory_list[i]['SHAPE'];
			if (ENGINE.Simulator.vars.lavatory_list4shape[shape]) {
				ENGINE.Simulator.vars.lavatory_list4shape[shape].push(ENGINE.Simulator.vars.lavatory_list[i]);
			} else {
				ENGINE.Simulator.vars.lavatory_list4shape[shape] = [];
				ENGINE.Simulator.vars.lavatory_list4shape[shape].push(ENGINE.Simulator.vars.lavatory_list[i]);
			}
		}

// console.log('initLavatory() : show lavatory_list');
// console.log(ENGINE.Simulator.vars.lavatory_list);
// console.log('initLavatory() : show lavatory_master');
// console.log(ENGINE.Simulator.vars.lavatory_master);
// console.log('initLavatory() : show lavatory_list4shape');
// console.log(ENGINE.Simulator.vars.lavatory_list4shape);

		// 初期処理の呼び出し
		ENGINE.Simulator.setup();
// console.log('initLavatory() - end.');
	},
	/**
	 * Relationデータの取得（CSVデータ→連想配列へ）
	 * 製品データファイル読み込み後のCallback関数
	 * 処理終了後、各callback関数共通でsetup()を呼び出す
	 *
	 */
/**
	initRelation: function(data) {
// console.log('-- get relation --');
		// 取得したテキストデータをCSV形式に変換
		// data = ENGINE.SimulatorCommon.parseCSV(data);
		var relation_list = ENGINE.SimulatorCommon.parseCSV(data);

		// CSV形式のデータをJSON形式のデータに変換
		// var relation_list = ENGINE.SimulatorCommon.parseCSV2JSON(data);
		var faucet_id, lavatory_id;
		var faucet_relation_list    = {};
		var lavatory_relation_list = {};
		for(var i=1,max=relation_list.length; i<max; i++) {
			lavatory_id = (relation_list[i][0] + '').trim();
			faucet_id    = (relation_list[i][1] + '').trim();

			// Faucet品番のキーと組み合わせ可能なLavatory品番をキーからなる連想配列（検索時の組み合わせ確認）
			if (faucet_relation_list[faucet_id]) {
				faucet_relation_list[faucet_id][lavatory_id] = 1;
			} else {
				faucet_relation_list[faucet_id] = {};
				faucet_relation_list[faucet_id][lavatory_id] = 1;
			}

			// Lavatory品番のキーと組み合わせ可能なLavatory品番をキーからなる連想配列（検索時の組み合わせ確認）
			if (lavatory_relation_list[lavatory_id]) {
				lavatory_relation_list[lavatory_id][faucet_id] = 1;
			} else {
				lavatory_relation_list[lavatory_id] = {};
				lavatory_relation_list[lavatory_id][faucet_id] = 1;
			}
		}

		ENGINE.Simulator.vars.faucet_relation_list    = faucet_relation_list;
		ENGINE.Simulator.vars.lavatory_relation_list = lavatory_relation_list;

// console.log('-- faucet base --');
// console.log(ENGINE.Simulator.vars.faucet_relation_list);
// console.log('-- lavatory base --');
// console.log(ENGINE.Simulator.vars.lavatory_relation_list);
		// 初期処理の呼び出し
		ENGINE.Simulator.setup();
	},
*/

	/**
	 * Relationデータの取得（CSVデータ→連想配列へ）
	 * 製品データファイル読み込み後のCallback関数
	 * 処理終了後、各callback関数共通でsetup()を呼び出す
	 *
	 */

	initRelation: function(data) {
// console.log('-- get relation --');
		// 取得したテキストデータをCSV形式に変換
		var relation_list = ENGINE.SimulatorCommon.parseCSV(data);

		var lavatory_id, faucet_id;
		var faucet_relation_list    = {};
		var lavatory_relation_list = {};

// console.log(relation_list);
		for(var i=2,imax=relation_list.length; i<imax; i++) {
			for(var j=1,jmax=relation_list[i].length; j<jmax; j++) {
				// 値がセットされている場合
				if (relation_list[i][j]) {
					lavatory_id = relation_list[1][j];
					faucet_id   = relation_list[i][0];

					// Faucet品番のキーと組み合わせ可能なLavatory品番をキーからなる連想配列（検索時の組み合わせ確認）
					if (faucet_relation_list[faucet_id]) {
						faucet_relation_list[faucet_id][lavatory_id] = 1;
					} else {
						faucet_relation_list[faucet_id] = {};
						faucet_relation_list[faucet_id][lavatory_id] = 1;
					}

					// Lavatory品番のキーと組み合わせ可能なLavatory品番をキーからなる連想配列（検索時の組み合わせ確認）
					if (lavatory_relation_list[lavatory_id]) {
						lavatory_relation_list[lavatory_id][faucet_id] = 1;
					} else {
						lavatory_relation_list[lavatory_id] = {};
						lavatory_relation_list[lavatory_id][faucet_id] = 1;
					}
				}
			}
		}

		ENGINE.Simulator.vars.faucet_relation_list    = faucet_relation_list;
		ENGINE.Simulator.vars.lavatory_relation_list = lavatory_relation_list;
// console.log('-- faucet base --');
// console.log(ENGINE.Simulator.vars.faucet_relation_list);
// console.log('-- lavatory base --');
// console.log(ENGINE.Simulator.vars.lavatory_relation_list);

		// 初期処理の呼び出し
		ENGINE.Simulator.setup();
	},
	//////////////////////////////////////////////////////////////////
	// [START] 各種初期化型の処理
	//////////////////////////////////////////////////////////////////
	setup: function() {
		// 必要データの読み込みチェック
		ENGINE.Simulator.vars.loaded--;
		if (ENGINE.Simulator.vars.loaded > 0) {
			return;
		}

		// cookie
		$.cookie.json = true;

		// 画面の初期化
		ENGINE.Simulator.initPanel();

		// 
		ENGINE.Simulator.initSpNavi();

		// ステップフローの初期化
		ENGINE.Simulator.initFlowNavi();

		// 画面遷移用リンクの初期化
		ENGINE.Simulator.initTransitionLink();

		// 処理実行用のリンクの初期化
		ENGINE.Simulator.initActionLink();

		var params = ENGINE.SimulatorCommon.getURLParameter();
		var refresh_navi_target = '';

		var target_id = '';
		if (params) {
// console.log('start param judege');
// console.log('show param');
// console.log(params);

			target_id = params['p'];

			var faucet_id     = params['fid'];
			var faucet_colour = params['fc'];
			var lavatory_id  = params['lid'];

			// Lavagoryの場合品番に#が使用されているものがあるためファイル名変換を行う
			lavatory_id = ENGINE.Simulator.converProductID2URL(lavatory_id, true);

			if (target_id) {
				refresh_navi_target = target_id;
// console.log(refresh_navi_target);
				// Over Head Shower
				if (faucet_id && faucet_colour && lavatory_id) {

					var faucet    = ENGINE.Simulator.searchProductAt('faucet-product', faucet_id);
					var lavatory = ENGINE.Simulator.searchProductAt('lavatory-product', lavatory_id);

					if (faucet && lavatory && faucet['COLOUR_' + faucet_colour]) {
						ENGINE.Simulator.condition['faucet-product']    = faucet_id;
						ENGINE.Simulator.condition['faucet-series']     = faucet['SERIES'];
						ENGINE.Simulator.condition['faucet-colour']     = faucet_colour;
						ENGINE.Simulator.condition['lavatory-product'] = lavatory_id;
						ENGINE.Simulator.condition['lavatory-shape']   = lavatory['SHAPE'];

						if (ENGINE.Simulator.func['move-' + target_id]) {

							// 画面遷移処理
							ENGINE.Simulator.func['move-' + target_id]();

							// 画面遷移処理の最終処理
							ENGINE.Simulator.terminateTransitionFunc('top', target_id);
						}
					}
				}


				if (ENGINE.Simulator.func['move-' + target_id]) {
					// 画面遷移処理
					ENGINE.Simulator.func['move-' + target_id]();
					// 画面遷移処理の最終処理
					ENGINE.Simulator.terminateTransitionFunc('top', target_id);
				}

			}

		}

		// サイドナビの初期化
		ENGINE.Simulator.refreshNavi(refresh_navi_target);

		// お気に入りの初期化
		ENGINE.Simulator.refreshFavorite();


		// 初期表示
		// this.moveFaucetSeries();
		// this.moveFaucetShape();
		// this.moveFaucetColour();
		// this.moveLavatoryShape();

// ENGINE.Simulator.condition = {
// 	'faucet-series'     : "ZA",
// 	'faucet-shape'      : null,
// 	'faucet-colour'     : "PN",
// 	'faucet-product'    : "TLP03301",
// 	'lavatory-shape'   : "vessel_outset",
// 	'lavatory-product' : "LW366",
// };


	},
	/**
	 * 画面の初期化（連想配列への登録）
	 *
	 */
	initPanel: function() {
		// 画面の初期化
		var $panel_list = $('[data-panel-id]');
		ENGINE.Simulator.panel_list = {};
		$panel_list.each(function($idx) {
			var $this = $(this);
			var panel_id = $this.data('panel-id');
			if ($this.hasClass('is-active')) {
				ENGINE.Simulator.active_panel_id = panel_id;
			}
			ENGINE.Simulator.panel_list[panel_id] = $this;
		});
	},
	/**
	 * 画面遷移用のリンクの初期化
	 *
	 */
	initTransitionLink: function($target) {
		var $transition_link = $target?$target.find('[data-transition-link]'):$('[data-transition-link]');
		$transition_link.each(function() {
			var $this = $(this);

			// 初期化されていないリンクのみ
			if (!$this.hasClass('is-ready')) {
				$this.addClass('is-ready');
				$this.on('click', function(e) {
					e.preventDefault();

					// classにis_inactiveがついている場合は処理しない
					if ($this.hasClass('is_inactive')) {
						return false;
					}

					// 遷移先画面IDの取得
					var target_id = $this.data('transition-link');

					// 製品検索タイプの取得（遷移先が製品一覧の場合のみ）
					var search_type = $this.data('search-type');
					var search_id   = $this.data('search-id');

					// 製品選択タイプの取得（製品一覧、カラー選択など）
					var select_type = $this.data('select-type');
					var select_id   = $this.data('select-id');


					var current_panel_id = ENGINE.Simulator.active_panel_id;

					// 画面遷移処理の呼び出し（固有処理）
					if (ENGINE.Simulator.func['move-' + target_id]) {

						if (select_type && select_id) {
// console.log('initTransitionLink() : has select id');
							// 左ナビの「Change」をClickされた場合
							if ( (select_type == 'chenge') && (select_id == 'plan') ) {

								if ( (target_id == 'faucet-series') || (target_id == 'faucet-shape') || (target_id == 'faucet-colour') ) {
									// ENGINE.Simulator.condition['faucet-product'] = '';
									// ENGINE.Simulator.condition['faucet-series']  = '';
									// ENGINE.Simulator.condition['faucet-shape']   = '';
									ENGINE.Simulator.condition['faucet-colour-before']  = ENGINE.Simulator.condition['faucet-colour'];
									ENGINE.Simulator.condition['faucet-colour']  = '';
								}
							}


							ENGINE.Simulator.condition[select_type] = select_id;
							ENGINE.Simulator.func['move-' + target_id](select_type, select_id);

							// 左ナビの「Change」をClickされた場合
							if ( (select_type == 'chenge') && (select_id == 'plan') ) {
								ENGINE.Simulator.swapSpNavi('plan');
							}

						// 検索用の引数あり
						} else if (search_type && search_id) {
// console.log('initTransitionLink() : has search id');
							ENGINE.Simulator.condition[search_type] = search_id;
							ENGINE.Simulator.func['move-' + target_id](search_type, search_id);

						} else  {
// console.log('initTransitionLink() : has default');
							ENGINE.Simulator.func['move-' + target_id]();
						}

						// サイドナビの初期化
						ENGINE.Simulator.refreshNavi(target_id);

					} else {
// console.log('initTransitionLink() : no function [' + 'move-' + target_id + ']');
					}


// console.log('initTransitionLink() : show condition.');
// console.log(ENGINE.Simulator.condition);

					// 画面遷移処理の最終処理
					ENGINE.Simulator.terminateTransitionFunc(current_panel_id, target_id);
				});
			}
		});
	},
	/**
	 * 画面遷移処理の最終処理
	 *
	 */
	 terminateTransitionFunc: function(current_panel_id, target_id) {
// console.log('terminateTransitionFunc() : call : ' + 'move-' + target_id);
// console.log('terminateTransitionFunc() : move : current[' + current_panel_id + '] => next[' + target_id + ']');

// console.log('before - history');
// console.log(ENGINE.Simulator.panel_history_list);

			// 画面遷移履歴の設定
			// 戻る(Back)処理
			if (target_id == 'back') {
				// 前の画面IDの取得
				target_id  = ENGINE.Simulator.popPanalHistory();

			// 同画面遷移はSKIP
			} else if (target_id == current_panel_id) {

			// それ以外の処理
			} else {
				// 画面遷移処理の呼び出し（共通処理）
				ENGINE.Simulator.registPanelHistory(target_id);
			}

			// Favorite以外の場合、SPナビの変更
			if (target_id != 'favorite') {
				ENGINE.Simulator.swapSpNavi('plan');
			}


			// TOPの場合、リセット処理
			if (target_id == 'top') {
				ENGINE.Simulator.resetPanalHistory();
				ENGINE.Simulator.moveTop();
			}

			// <body>タグに表示画面固有のclassを追加
			$('body').removeClass('uq_faucet-lavatory-' + current_panel_id).addClass('uq_faucet-lavatory-' + target_id);
			if (target_id == 'top') {
				$('body').removeClass('is_underlayer');
			} else {
				$('body').addClass('is_underlayer');
			}

			// 画面展開
			ENGINE.Simulator.panel_list[current_panel_id].removeClass('is-active');
			ENGINE.Simulator.panel_list[target_id].addClass('is-active');
			ENGINE.Simulator.active_panel_id = target_id;

// console.log('after - history');
// console.log(ENGINE.Simulator.panel_history_list);

			// ステップフローの更新
			ENGINE.Simulator.resetFlowNavi(target_id, current_panel_id);

			// 結果場面・Favarite詳細の場合、結果表示用の処理を呼び出す
			if ( (target_id == 'result') || (target_id == 'saved') ) {
				ENGINE.SimulatorCommon.stageFit();
			}

			// スクロール位置のリセット
      $('body,html').animate({
        scrollTop: 0
      }, 1);

	 },
	/**
	 * 処理実行用のリンクの初期化
	 *
	 */
	initActionLink: function($target) {
// console.log('initActionLink() - start.');

		var $action_link = $target?$target.find('[data-action-link]'):$('[data-action-link]');
		$action_link.each(function() {
			var $this = $(this);

			// 遷移先画面IDの取得
			var target_id = $this.data('action-link');

// console.log('initActionLink() : target_id[' + target_id + ']');

			// 初期化されていないリンクのみ
			if (!$this.hasClass('is-ready')) {
				$this.addClass('is-ready');
				$this.on('click', function(e) {
					e.preventDefault();

					// 製品選択タイプの取得（製品一覧、カラー選択など）
					var select_type = $this.data('select-type');
					var select_id   = $this.data('select-id');

					var current_panel_id = ENGINE.Simulator.active_panel_id;

// console.log(target_id);


					// 画面遷移処理の呼び出し（固有処理）
					if (ENGINE.Simulator.func['action-' + target_id]) {
						if (select_type && select_id) {
							ENGINE.Simulator.condition[select_type] = select_id;
							ENGINE.Simulator.func['action-' + target_id](select_type, select_id, $(this));

						} else  {
// console.log('initActionLink() : has default');
							ENGINE.Simulator.func['action-' + target_id]($(this));
						}
					}

// console.log('initActionLink() : show condition.');
// console.log(ENGINE.Simulator.condition);

				});
			}
		});
// console.log('initActionLink() - end.');
	},
	/**
	 * スマホ版ヘッダータブの初期化
	 *
	 */
	initSpNavi: function() {
		$('.js_sp_navi li').each(function() {
			var $tab = $(this);

			$tab.on('click', function() {
				var target_panel_id = '';
				var target_id = $tab.data('select-id');

				// 切り替え処理の呼び出し
				ENGINE.Simulator.swapSpNavi(target_id, $(this));
			});

		});
	},
	/**
	 * スマホ版ヘッダータブの切り替え
	 *
	 */
	swapSpNavi: function(target_id, $target) {

		target_id = target_id?target_id:'plan';

		var $navi = $('.js_sp_navi li');
		var $plan = $('.js_navi');
		var $current_tab = $('.js_sp_navi li.is_active');
		var $target_tab  = ($target && $target.length>0)?$target:$('.js_sp_navi li[data-select-id="' + target_id + '"]');

		var current_id = ($current_tab.length>0)?$current_tab.data('select-id'):'plan';

		// Current切り替え
		$navi.removeClass('is_active');
		$target_tab.addClass('is_active');

		// 表示切り替え
		$('body').attr('sp-show-tab', target_id);

		// favoriteから他画面を表示する場合は画面遷移させる
		// if (current_id == 'favorite') {
		// 	var target_panel_id  = ENGINE.Simulator.popPanalHistory();
		// 	ENGINE.Simulator.terminateTransitionFunc(ENGINE.Simulator.active_panel_id, target_panel_id);
		// }

		// favorite（比較画面のメイン画面のみ）を表示
		if (target_id == 'favorite') {
			// // $plan.removeClass('is_show');
			// ENGINE.Simulator.moveCompare();
			// // 画面遷移処理の最終処理
			// ENGINE.Simulator.terminateTransitionFunc(ENGINE.Simulator.active_panel_id, 'compare');

		// choice / 現在の選択結果画面（PC版の左ナビ）を表示
		} else if (target_id == 'choice') {
			// $plan.addClass('is_show');

		// plan / 現在のメイン画面（PC版のメイン画面）を表示
		} else if (target_id == 'plan') {
			// $plan.removeClass('is_show');
			// ENGINE.Simulator.terminateTransitionFunc(ENGINE.Simulator.active_panel_id, target_panel_id);
			// var $target = $('#favorite_nav_list4saved');
		}
	},
	/**
	 * ステップフローの初期化
	 *
	 */
	initFlowNavi: function() {

		var $container = $('.js_flow_nav');
		var $all_items = $container.find('[data-flow-id]');
		var items  = {};
		var links = {};
		$all_items.each(function() {
			var $this = $(this);
			var id = $this.data('flow-id');
			var $link = $this.find('a');
			items[id] = $this;
			links[id] = $link;
		});

		ENGINE.Simulator.flow_nav = {
			'container': $container,
			'all-items': $all_items,
			'items': items,
			'links': links
		};
	},
	//////////////////////////////////////////////////////////////////
	// [END] 各種初期化型の処理
	//////////////////////////////////////////////////////////////////


	/**
	 * 画面遷移リストに画面IDを保存
	 *
	 */
	registPanelHistory: function(panel_id) {
		ENGINE.Simulator.panel_history_list.push(panel_id);
	},
	/**
	 * 画面遷移リストがら画面IDを取得
	 *
	 */
	popPanalHistory: function() {
		if (ENGINE.Simulator.panel_history_list.length > 0) {
			ENGINE.Simulator.panel_history_list.pop();
		}

		var length   = ENGINE.Simulator.panel_history_list.length;
		var panel_id = 'top';
		if (length > 0) {
			panel_id = ENGINE.Simulator.panel_history_list[length-1];
		}

		return panel_id;
	},
	/**
	 * 画面遷移リストの破棄
	 *
	 */
	resetPanalHistory: function() {
		ENGINE.Simulator.panel_history_list = [];
	},


	//////////////////////////////////////////////////////////////////
	// [START] 画面遷移時の処理（シミュレータ固有）
	//////////////////////////////////////////////////////////////////
	/**
	 * 戻る処理
	 *
	 */
	moveBack: function() {
		// TODO: 戻る処理時に必要な処理があれば記述
	},
	/**
	 * TOPに戻る処理
	 *
	 */
	moveTop: function() {
// console.log('moveTop() - start.');

		// 保存データのリセット
		ENGINE.Simulator.condition = {};

		// サイドナビのリフレッシュ
		ENGINE.Simulator.refreshNavi();

// console.log('moveTop() - end.');
	},
	/**
	 * Faucet / Series パネルの表示
	 *
	 */
	moveFaucetSeries: function() {
// console.log('moveFaucetSeries() - start.');

		// Lavatoryが選択されている場合、組み合わせ可能なシリーズの取得
		// 選択されているlavatory品番
		var selected_lavatory = ENGINE.Simulator.condition['lavatory-product']?ENGINE.Simulator.condition['lavatory-product']:false;
		var valid_series_list = {};
		if (selected_lavatory) {
			// 組み合わせ可能なfaucetの品番リストを取得
			var refine_faucet_list = ENGINE.Simulator.vars.lavatory_relation_list[selected_lavatory];
			var refine_faucet_product, refine_faucet_series;
// console.log('moveFaucetSeries() : selected lavatory [' + selected_lavatory + ']');
// console.log('moveFaucetSeries() : refine faucet list');
// console.log(refine_faucet_list);
// console.log('moveFaucetSeries() : refine faucet list - loop start');

			// 組み合わせ可能なfaucetの品番リストに格納されている品番数分LOOP
			for(var refine_faucet_id in refine_faucet_list) {
				// faucet製品マスタより製品情報を取得
				refine_faucet_product = ENGINE.Simulator.vars.faucet_master[refine_faucet_id];
// console.log(refine_faucet_product);
				// 製品に紐づくシリーズを取得し、連想配列に可能（表示、非表示の制御に使用する）
				if (refine_faucet_product && refine_faucet_product['SERIES']) {
					refine_faucet_series = refine_faucet_product['SERIES'];
					valid_series_list[refine_faucet_series] = true;
				}
			}
// console.log('moveFaucetSeries() : refine faucet list - loop end');
// console.log(valid_series_list);
		}

		// HTMLコード格納用
		var code_anchor     = "";
		var code_list       = "";
		var code_list_child = "";

		// Seriesデータの取得
		var list = ENGINE.Simulator.settings['faucet_series'];

		var count = 0;
		var cat_size  = ['large', 'middle', 'small'];
		var ttl_cls = '';
		var selected_colour = ENGINE.Simulator.condition['faucet-colour'];
		var selected_shape  = ENGINE.Simulator.condition['faucet-shape'];
		var show_colour = '';
		var series_list, colour_list, shape_list, is_colour_exist, is_shape_exist, product_image, faucet_id, faucet;

		// Shapeが選択されている場合のデフォルト商品の上書き
		if (selected_shape && ENGINE.Simulator.settings['faucet_shape_series'][selected_shape]) {
			list = ENGINE.Simulator.settings['faucet_shape_series'][selected_shape];
		}

		for(var series_cat in list) {
			series_list = list[series_cat];

			code_list_child = '';

			for(var series in series_list) {
				// lavatoryが選択されていて、組み合わせ可能製品に該当するシリーズが存在しない場合、HTMLコードを生成しない
				if (selected_lavatory && !valid_series_list[series]) {
// console.log('moveFaucetSeries() : lavatory relation => NG');
					continue;
				}

// console.log('initFaucet() : show faucet_list4series');
// console.log(ENGINE.Simulator.vars.faucet_list4series);
// console.log('initFaucet() : show faucet_list4shape');
// console.log(ENGINE.Simulator.vars.faucet_list4shape);
// console.log('initFaucet() : show faucet_list4colour');
// console.log(ENGINE.Simulator.vars.faucet_list4colour);
				if (!ENGINE.Simulator.vars.faucet_list4series[series] || (ENGINE.Simulator.vars.faucet_list4series[series].length == 0)) {
					continue;
				}

				// colourの判定（colourが選択済みの場合、紐づく製品にその色があるかどうかを判断する
				if (selected_colour) {
					colour_list = ENGINE.Simulator.vars.faucet_list4colour[selected_colour];

// console.log('selected is [' + selected_colour + '] judege list => ');
// console.log(colour_list);

					if (colour_list) {
						is_colour_exist = false;
						for(var idx=0,max=colour_list.length; idx<max; idx++) {
							if (colour_list[idx]['SERIES'] == series) {
								is_colour_exist = true;
								break;
							}
						}

						if (!is_colour_exist) {
// console.log('moveFaucetSeries() : colour relation => NG');
							continue;
						}
					} else {
						continue;
					}
				}

				// shapeの判定（shapeが選択済みの場合、紐づく製品にその色があるかどうかを判断する
				if (selected_shape) {

					shape_list = ENGINE.Simulator.vars.faucet_list4shape[selected_shape];
					if (shape_list) {
						is_shape_exist = false;
						for(var idx=0,max=shape_list.length; idx<max; idx++) {
							if (shape_list[idx]['SERIES'] == series) {
								is_shape_exist = true;
								break;
							}
						}
						if (!is_shape_exist) {
// console.log('moveFaucetSeries() : shape relation => NG');
							continue;
						}
					}
				}

				// シリーズごとのHTMLコードの生成
				// 画像色は選択されている
				show_colour = selected_colour?selected_colour:series_list[series]["colour"];

				faucet_id = series_list[series]["product_id"];
				faucet = ENGINE.Simulator.vars.faucet_master[faucet_id];

				code_list_child += '<li><a href="#faucet-product" data-transition-link="faucet-product" data-search-type="faucet-series" data-search-id="' + series + '">';
				code_list_child += '<div class="m_col__img">' + ENGINE.Simulator.generateCodeProductImage4List('faucet', faucet, show_colour) + '</div>';
				code_list_child += '<div class="m_series__name"><p>' + series + '</p></div>';
				code_list_child += '</a></li>';
			}

			// 表示するシリーズ情報が存在する場合、シリーズカテゴリ用のHTMLコードを生成
			if (code_list_child) {
				code_anchor += '<li><a href="#series_' + series_cat + '" class="js_smoothScroll"><span>' + series_cat + '</span><small>' + ENGINE.Simulator.messages['category_series'] + '</small></a></li>';

				ttl_cls = (count > 0)?'m_rsp_mgt30':'';
				code_list += '<h2 id="series_' + series_cat + '" class="m_ttl__base ' + ttl_cls + ' m_rsp_mgb15"><span>' + series_cat + '</span><small>' + ENGINE.Simulator.messages['category_series'] + '</small></h2>';
				code_list += '<div class="m_col__' + cat_size[count] + '"><ul>';
				code_list += code_list_child;
				code_list += '</ul></div>';

				count++;
			}

			if (count > 2) {
				count = 2;
			}
		}

		// アンカーの表示
		var $anchor_holder = $('#faucet_series_anchor');
		if (code_anchor) {
			$anchor_holder.html(code_anchor);
			$anchor_holder.show();
		} else {
			$anchor_holder.hide();
		}

		// リストの表示
		var $list_holder = $('#faucet_series_list');
		$list_holder.html(code_list);

		// リンクの初期化
		ENGINE.Simulator.initTransitionLink($list_holder);

// console.log('moveFaucetSeries() - end.');

	},
	/**
	 * Faucet / Shape パネルの表示
	 *
	 */
	moveFaucetShape: function() {
// console.log('moveFaucetShape() - start.');

		// Lavatoryが選択されている場合、組み合わせ可能なShapeの取得
		// 選択されているlavatory品番
		var selected_lavatory = ENGINE.Simulator.condition['lavatory-product']?ENGINE.Simulator.condition['lavatory-product']:false;
		var valid_shape_list = {};
		if (selected_lavatory) {
			// 組み合わせ可能なfaucetの品番リストを取得
			var refine_faucet_list = ENGINE.Simulator.vars.lavatory_relation_list[selected_lavatory];
			var refine_faucet_product, refine_faucet_shape;

			// 組み合わせ可能なfaucetの品番リストに格納されている品番数分LOOP
			for(var refine_faucet_id in refine_faucet_list) {
				// faucet製品マスタより製品情報を取得
				refine_faucet_product = ENGINE.Simulator.vars.faucet_master[refine_faucet_id];
				// 製品に紐づくShapeを取得し、連想配列に可能（表示、非表示の制御に使用する）
				if (refine_faucet_product && refine_faucet_product['SHAPE']) {
					refine_faucet_shape = refine_faucet_product['SHAPE'];
					valid_shape_list[refine_faucet_shape] = true;
				}
			}
		}


		var code_anchor = "";
		var code_list   = "";

		// Seriesデータの取得
		var list = ENGINE.Simulator.settings['faucet_shape'];

		var count = 0;
		var product_image, faucet_id, faucet;
		for(var shape in list) {

			// Shapeを持つ製品が存在するかのチェック
			if (!ENGINE.Simulator.vars.faucet_list4shape[shape] || (ENGINE.Simulator.vars.faucet_list4shape[shape].length == 0)) {
				continue;
			}

			// lavatoryが選択されていて、組み合わせ可能製品に該当するShapeが存在しない場合、HTMLコードを生成しない
			if (selected_lavatory && !valid_shape_list[shape]) {
				continue;
			}

			code_anchor += '<li><a href="#shape_' + shape + '" class="js_smoothScroll"><small>' + ENGINE.Simulator.messages['faucet_shape_' + shape] + '</small></a></li>';

			faucet_id = list[shape]["product_id"];
			faucet = ENGINE.Simulator.vars.faucet_master[faucet_id];

			code_list += '<li id="shape_' + shape + '"><div class="m_rsp_pdb10"><h2 class="m_ttl__base"><small>' + ENGINE.Simulator.messages['faucet_shape_' + shape] + '</small></h2></div>';
			code_list += '<a href="#faucet-series" data-transition-link="faucet-series" data-search-type="faucet-shape" data-search-id="' + shape + '">';
			code_list += '<div class="m_col__img">' + ENGINE.Simulator.generateCodeProductImage4List('faucet', faucet, list[shape]["colour"]) + '</div>';
			code_list += '</a></li>';

		}

		// アンカーの表示
		// var $anchor_holder = $('#faucet_shape_anchor');
		// if (code_anchor) {
		// 	$anchor_holder.html(code_anchor);
		// 	$anchor_holder.show();
		// } else {
		// 	$anchor_holder.hide();
		// }

		// リストの表示
		var $list_holder = $('#faucet_shape_list');
		$list_holder.html(code_list);

		// リンクの初期化
		ENGINE.Simulator.initTransitionLink($list_holder);

// console.log('moveFaucetShape() - end.');
	},
	/**
	 * Faucet / Colour パネルの表示
	 *
	 */
	moveFaucetColour: function() {
// console.log('moveFaucetColour() - start.');

		// Colourデータの取得
		var list = ENGINE.Simulator.settings['faucet_colour'];
		var colour_list, colour_cat_name, product_image, faucet_id, faucet;

		// Lavatoryが選択されている場合、組み合わせ可能なColourの取得
		// 選択されているlavatory品番
		var selected_lavatory = ENGINE.Simulator.condition['lavatory-product']?ENGINE.Simulator.condition['lavatory-product']:false;
		var valid_colour_list = {};
		if (selected_lavatory) {
			// 組み合わせ可能なfaucetの品番リストを取得
			var refine_faucet_list = ENGINE.Simulator.vars.lavatory_relation_list[selected_lavatory];
			var refine_faucet_product, refine_faucet_colour;

			// Colour情報に設定されている色数分LOOP
			for(var colour_cat in list) {
				colour_list = list[colour_cat];

				// faucet製品マスタより製品情報を取得
				// refine_faucet_product = ENGINE.Simulator.vars.faucet_master[refine_faucet_id];
				for(var colour in colour_list) {
					// 有効なColourリストに値がない場合、製品情報をLOOP
					if (!valid_colour_list[colour]) {
						// 組み合わせ可能なfaucetの品番リストに格納されている品番数分LOOP
						for(var refine_faucet_id in refine_faucet_list) {
							// faucet製品マスタより製品情報を取得
							refine_faucet_product = ENGINE.Simulator.vars.faucet_master[refine_faucet_id];
							// 取得した製品情報の該当Colourにフラグが立っている場合、有効なColourリストにフラグをたて、LOOP終了
							if (refine_faucet_product['COLOUR_' + colour]) {
								valid_colour_list[colour] = true;
								break;
							}
						}
					}
				}
			}
		}


		var code_anchor     = "";
		var code_list       = "";
		var code_list_child = "";

		var count = 0;
		var ttl_cls = '';

		for(var colour_cat in list) {
			colour_list = list[colour_cat];
			colour_cat_name = (colour_cat == 'bicolour')?ENGINE.Simulator.messages['category_colour_bicolour']:ENGINE.Simulator.messages['category_colour_normal']

			code_list_child = '';
			for(var colour in colour_list) {

				// Colourを持つ製品が存在するかのチェック
				if (!ENGINE.Simulator.vars.faucet_list4colour[colour] || (ENGINE.Simulator.vars.faucet_list4colour[colour].length == 0)) {
					continue;
				}

				// Lavatoryとの組み合わせチェック
				if (selected_lavatory && !valid_colour_list[colour]) {
// console.log('moveFaucetSeries() : lavatory relation => NG');
					continue;
				}


				faucet_id = colour_list[colour]["product_id"];
				faucet = ENGINE.Simulator.vars.faucet_master[faucet_id];

				// code_list += '<li><a href="#faucet-product" data-transition-link="faucet-product" data-search-type="faucet-colour" data-search-id="' + colour + '">';
				code_list_child += '<li><a href="#faucet-series" data-transition-link="faucet-series" data-search-type="faucet-colour" data-search-id="' + colour + '">';
				code_list_child += '<div class="m_colour__box">';
				code_list_child += '<div class="m_col__img">' + ENGINE.Simulator.generateCodeProductImage4List('faucet', faucet, colour) + '</div>';
				code_list_child += '<div class="m_colour__img is_' + colour + '"></div>';
				code_list_child += '<div class="m_colour__name"><p>' + ENGINE.Simulator.messages['colour_' + colour] + '</p></div>';
				code_list_child += '</div>';
				code_list_child += '</a></li>';
			}

			if (code_list_child) {
				code_anchor += '<li><a href="#colour_' + colour_cat + '" class="js_smoothScroll"><small>' + colour_cat_name + '</small></a></li>';

				ttl_cls = (count > 0)?'m_rsp_mgt30':'';
				code_list += '<h2 id="colour_' + colour_cat + '" class="m_ttl__base ' + ttl_cls + ' m_rsp_mgb15"><small>' + colour_cat_name + '</small></h2>';
				code_list += '<div class="m_col__large"><ul>';
				code_list += code_list_child;
				code_list += '</ul></div>';


				count++;
				if (count > 2) {
					count = 2;
				}
			}
		}

		// アンカーの表示
		var $anchor_holder = $('#faucet_colour_anchor');
		if (code_anchor) {
			$anchor_holder.html(code_anchor);
			$anchor_holder.show();
		} else {
			$anchor_holder.hide();
		}

		var $list_holder = $('#faucet_colour_list');
		$list_holder.html(code_list);

		// リンクの初期化
		ENGINE.Simulator.initTransitionLink($list_holder);

// console.log('moveFaucetColour() - end.');
	},
	/**
	 * Lavatory / Shape パネルの表示
	 *
	 */
	moveFaucetProduct: function(search_type, search_id) {
// console.log('moveFaucetProduct() - start.');
// console.log('moveFaucetProduct() : search : type[' + search_type + '][' + search_id + ']');

		// HTMLコード格納用
		var code_anchor     = "";
		var code_list       = "";
		var code_list_child = "";

		// 遷移先の判定
		var transition_link = 'lavatory-shape';
		// lavatoryが選択されている場合は結果画面、選択されていない場合は洗面器の選択フローへ
		var selected_lavatory = ENGINE.Simulator.condition['lavatory-product'];

		// faucetの検索軸で何が選択されているかにより、遷移先と表示内容を制御
		var selected_series = ENGINE.Simulator.condition['faucet-series'];
		var selected_colour = ENGINE.Simulator.condition['faucet-colour'];
		var selected_shape  = ENGINE.Simulator.condition['faucet-shape'];

		// 遷移先の制御
		if (selected_colour) {
			if (selected_lavatory) {
				transition_link = 'result';
			} else {
				transition_link = 'lavatory-shape';
			}
		} else {
			transition_link = 'faucet-select-colour';
		}

// console.log('moveFaucetProduct() : faucet product - base colour : ' + selected_colour);
// console.log('moveFaucetProduct() : faucet product - transition link : ' + transition_link);
// console.log('moveFaucetProduct() : selected');
// console.log('series : ' + selected_series);
// console.log('shape  : ' + selected_shape);
// console.log('colour : ' + selected_colour);

		// 製品データの取得
		// var list = ENGINE.Simulator.vars.faucet_list;
		var list = ENGINE.Simulator.searchProducts4Faucet();

// console.log('list : ');
// console.log(list);

		// 表示する分類（何でカテゴライズするか）の制御
		// shapeが選択されている場合はSeriesで分類する
		var show_colour, product_image;
		if (selected_shape) {

			//
			code_list_child = '';
			for(var i=0,max=list.length; i<max; i++) {

				show_colour = selected_colour?selected_colour:list[i]["COLOUR_DEFAULT"];

				code_list_child += '<li><a href="#faucet-product" data-transition-link="' + transition_link +'" data-select-type="faucet-product" data-select-id="' + list[i]["PRODUCT_ID"] + '">';
				code_list_child += '<div class="m_col__img">' + ENGINE.Simulator.generateCodeProductImage4List('faucet', list[i], show_colour)  + '</div>';

				code_list_child += '<div class="m_series__name"><p>' + list[i]["PRODUCT_ID"] + '</p></div>';

				// 技術アイコン、デザインアイコン
				code_list_child += ENGINE.Simulator.generateCode4IconList(list[i], true);

				code_list_child += '</a></li>';
			}

			if (code_list_child) {
				code_list += '<h2 id="single_w_pop_up" class="m_ttl__base m_rsp_mgb15"><span>' + selected_series + ENGINE.Simulator.messages['category_series'] + '</span></h2>';
				code_list += '<div class="m_col__large"><ul>';
				code_list += code_list_child;
				code_list += '</ul></div>';
			}

		// shapeが選択されていない場合、Shapeで分類する
		} else {

			// 選択されているShape / SeriesのリストをSeriesベースに書き換える
			// このタイミングではSeriesが必ず選択されている
			var series_shape_list = ENGINE.Simulator.settings['faucet_shape_series'];
			var valid_series_shape_list = {};
			var pickup_product = '';

			for(var shape_id in series_shape_list) {
				for(var series_cat in series_shape_list[shape_id]) {
					for(var series in series_shape_list[shape_id][series_cat]) {
						if (series == selected_series) {

							pickup_product = series_shape_list[shape_id][series_cat][series];
							if (pickup_product['product_id']) {
								if (!valid_series_shape_list[shape_id]) {
									valid_series_shape_list[shape_id] = {};
								}
								valid_series_shape_list[shape_id][series] = series_shape_list[shape_id][series_cat][series];
							}
						}
					}
				}
			}

			var count   = 0;
			var ttl_cls = '';
			var base = false;

			// 有効なShapeのリスト数分LOOP
			for(var shape_id in valid_series_shape_list) {
				pickup_product = valid_series_shape_list[shape_id][selected_series];

				code_list_child = '';
				// 製品数LOOP（製品情報のShapeと親LOOPで表示しようとしているShapeが同じ場合のみ、出力処理を行う
				for(var i=0,max=list.length; i<max; i++) {
					//
					if (list[i]['SHAPE'] != shape_id) {
						continue;
					}

// console.log('loop ');
// console.log('series : ' + selected_series);
// console.log('shape  : ' + shape_id);
// console.log('product : ');
// console.log(list[i]);
// console.log(pickup_product);
// console.log('default colour : ' + pickup_product['colour']);

					show_colour = selected_colour?selected_colour:pickup_product['colour'];

					code_list_child += '<li><a href="#faucet-product" data-transition-link="' + transition_link +'" data-select-type="faucet-product" data-select-id="' + list[i]["PRODUCT_ID"] + '">';
					code_list_child += '<div class="m_col__img">' + ENGINE.Simulator.generateCodeProductImage4List('faucet', list[i], show_colour)  + '</div>';

					code_list_child += '<div class="m_series__name"><p>' + list[i]["PRODUCT_ID"] + '</p></div>';

					// 技術アイコン、デザインアイコン
					code_list_child += ENGINE.Simulator.generateCode4IconList(list[i], true);

					code_list_child += '</a></li>';
				}

				if (code_list_child) {
					ttl_cls = (count > 0)?'m_rsp_mgt30':'';

					code_anchor += '<li><a href="#' + shape_id + '" class="js_smoothScroll"><small>' + ENGINE.Simulator.messages['faucet_shape_' + shape_id] + '</small></a></li>';

					code_list += '<h2 id="' + shape_id + '" class="m_ttl__base m_rsp_mgb15 ' + ttl_cls + '"><small>' + ENGINE.Simulator.messages['faucet_shape_' + shape_id] + '</small></h2>';
					code_list += '<div class="m_col__large"><ul>';
					code_list += code_list_child;
					code_list += '</ul></div>';

					count++;
				}
			}
		}

		// アンカーの表示
		var $anchor_holder = $('#faucet_product_anchor');
		if (code_anchor) {
			$anchor_holder.html(code_anchor);
			$anchor_holder.show();
		} else {
			$anchor_holder.hide();
		}

		// リストの表示
		var $list_holder = $('#faucet_product_list');
		$list_holder.html(code_list);

		// リンクの初期化
		ENGINE.Simulator.initTransitionLink($list_holder);

// console.log('moveFaucetProduct() - end.');
	},
	/**
	 * 色選択画面の表示
	 *
	 */
	moveFaucetSelectColour: function(search_type, search_id) {

// console.log('moveFaucetSelectColour() - start.');

		var selected_faucet = ENGINE.Simulator.condition['faucet-product'];

		// 製品データの取得
		var product = ENGINE.Simulator.searchProductAt('faucet-product', selected_faucet);

// console.log('moveFaucetSelectColour() : show product');
// console.log(product);
		var default_colour = product['COLOUR_DEFAULT'];
		if (ENGINE.Simulator.condition['faucet-colour']) {
			default_colour = ENGINE.Simulator.condition['faucet-colour'];
		} else {
			ENGINE.Simulator.condition['faucet-colour'] = default_colour;
		}

		// 選択されているカラーの表示
		var code_selected_colour = '';
		var colour_name = ENGINE.Simulator.messages['colour_' + default_colour];

		code_selected_colour += '<div class="m_navi__colour--selected is_default_show">';
		code_selected_colour += '<div class="m_navi__colour--balloon-inner js_nav_faucet_colour">';
		code_selected_colour += '<div class="m_navi__colour--balloon-img is_' + default_colour + '"></div>';
		code_selected_colour += '<div class="m_navi__colour--balloon-txt"><p>' + colour_name + '</p></div>';
		code_selected_colour += '</div>';
		code_selected_colour += '</div>';

		// 製品カラー情報の取得
		var code_faucet_colour = ENGINE.Simulator.generateCode4ColourList(product, default_colour, 'm_colour-select__list', 'action', 'select-faucet-colour', 'faucet-colour');

		// 製品画像
		var code_product_image = ENGINE.Simulator.generateCodeProductImage4List('faucet', product, default_colour);

		code_product_image = '<div class="m_colour-select__main m_auto" id="faucet_product_image">' + code_product_image + '</div>';

		// 製品名
		var code_product_name = selected_faucet + ' (' + product['SERIES'] + ENGINE.Simulator.messages['category_series'] + ')';

		// 技術アイコン・デザインアイコン
		var code_icon_list = ENGINE.Simulator.generateCode4IconList(product, false);
		if (code_icon_list) {
			code_icon_list = '<ul class="m_list__inline m_list__icon">' + code_icon_list + '</ul>';
		}

		// 製品URL
		var detail_url = product['PRODUCT_URL'];
		var code_product_url = '';
		if (detail_url) {
			code_product_url = '<a href="' + detail_url + '" target="_blank"><i class="m_icon__blank--gray m_mgr5"></i>' + ENGINE.Simulator.messages['product_link'] + '</a>';
		}


		// Nextリンクの設定
		var code_next_link = '';
		var is_selected_lavatory = false;
		var next_link_text, next_link_transition_id;
		if ( ENGINE.Simulator.condition['lavatory-product'] && (ENGINE.Simulator.condition['lavatory-product'] != '') ) {
			is_selected_lavatory = true;
		}
		if (is_selected_lavatory) {
			next_link_transition_id = 'result';
			next_link_text = ENGINE.Simulator.messages['result_link'];
		} else {
			next_link_transition_id = 'lavatory-shape';
			next_link_text = ENGINE.Simulator.messages['next_lavatory_link'];
		}
		code_next_link += '<a href="" class="m_auto" data-transition-link="' + next_link_transition_id + '">' + next_link_text + '<i class="m_icon__arrow--right-white m_mgl5"></i></a>';


		// HTMLの整形
		var code = '';
		// 画像
		code += code_product_image;

		code += '<div class="m_colour-select__box m_mgt30">';
		code += '<div class="m_layout m_colour-select__layout">';
		// 製品名
		code += '<h3 class="m_ttl__middle m_mgr25">' + code_product_name + '</h3>';
		// 技術アイコン
		code += code_icon_list;
		// 施肥品URL
		code += '<p class="m_btn__detail m_colour-select__detail">' + code_product_url + '</p>';
		code += '</div>';
		// 見出し
		code += '<h4 class="m_ttl__small m_mgt30">' + ENGINE.Simulator.messages['result_link'] + '</h4>';

		// 選択されているカラーの表示
		code += code_selected_colour;

		// 色選択欄
		code += '<ul class="m_list__inline m_colour-select__list js_colour__check" id="faucet_product_select_colour">';
		code += code_faucet_colour;
		code += '</ul>';
		code += '</div>';

		// 次ページURL
		code += '<p class="m_btn__black m_mgt40">';
		code += code_next_link;
		code += '</p>';

		var $target = $('#faucet_select_colour');
		$target.html(code);


		ENGINE.Simulator.initActionLink($target);
		ENGINE.Simulator.initTransitionLink($target);

// console.log('moveFaucetSelectColour() - end.');
	},
	/**
	 * Lavatory / Shape パネルの表示
	 *
	 */
	moveLavatoryShape: function() {
// console.log('moveLavatoryShape() - start.');

		// faucetが選択されている場合、組み合わせ可能なShapeの取得
		// 選択されているfaucet品番
		var selected_faucet = ENGINE.Simulator.condition['faucet-product']?ENGINE.Simulator.condition['faucet-product']:false;
		var valid_shape_list = {};
		if (selected_faucet) {
			// 組み合わせ可能なlavatoryの品番リストを取得
			var refine_lavatory_list = ENGINE.Simulator.vars.faucet_relation_list[selected_faucet];
			var refine_lavatory_product, refine_lavatory_shape;
// console.log('moveLavatoryShape() : selected faucet [' + selected_faucet + ']');
// console.log('moveLavatoryShape() : refine lavatory list');
// console.log(refine_lavatory_list);
// console.log('moveLavatoryShape() : refine lavatory list - loop start');
			// 組み合わせ可能なlavatoryの品番リストに格納されている品番数分LOOP
			for(var refine_lavatory_id in refine_lavatory_list) {
				// faucet製品マスタより製品情報を取得
				refine_lavatory_product = ENGINE.Simulator.vars.lavatory_master[refine_lavatory_id];
// console.log('moveLavatoryShape() : show product');
// console.log(refine_lavatory_product);
				// 製品に紐づくシリーズを取得し、連想配列に可能（表示、非表示の制御に使用する）
				if (refine_lavatory_product && refine_lavatory_product['SHAPE']) {
					refine_lavatory_shape = refine_lavatory_product['SHAPE'];
					valid_shape_list[refine_lavatory_shape] = true;
				}
			}
// console.log('refine lavatory list - loop end');
// console.log(valid_shape_list);
		}

		// HTMLコード格納用
		var code_anchor = "";
		var code_list   = "";

		// Seriesデータの取得
		var list = ENGINE.Simulator.settings['lavatory_shape'];

		var count = 0;
		var product_image;

		code_list += '<ul>';

		for(var shape in list) {

			// Shapeを持つ製品が存在するかのチェック
			if (!ENGINE.Simulator.vars.lavatory_list4shape[shape] || (ENGINE.Simulator.vars.lavatory_list4shape[shape].length == 0)) {
				continue;
			}

			// lavatoryが選択されていて、組み合わせ可能製品に該当するシリーズが存在しない場合、HTMLコードを生成しない
			if (selected_faucet && !valid_shape_list[shape]) {
				continue;
			}

			code_anchor += '<li><a href="#shape_lavatory_' + shape + '" class="js_smoothScroll"><small>' + ENGINE.Simulator.messages['lavatory_shape_' + shape] + '</small></a></li>';

			var product_id = list[shape]["product_id"];
			var product  = ENGINE.Simulator.searchProductAt('lavatory-product', product_id);

			code_list += '<li id="shape_lavatory_' + shape + '"><div class="m_rsp_pdb20"><h2 class="m_ttl__base">';
			code_list += '<small>' + ENGINE.Simulator.messages['lavatory_shape_' + shape] + '</small></h2></div>';
			code_list += '<a href="#lavatory-product" data-transition-link="lavatory-product" data-search-type="lavatory-shape" data-search-id="' + shape + '">';
			code_list += '<div class="m_col__img">' + ENGINE.Simulator.generateCodeProductImage4List('lavatory', product) + '</div>';
			code_list += '</a></li>';

		}
		code_list += '</ul>';

		// アンカーの表示
		var $anchor_holder = $('#lavatory_shape_anchor');
		if (code_anchor) {
			$anchor_holder.html(code_anchor);
			$anchor_holder.show();
		} else {
			$anchor_holder.hide();
		}

		// リストの表示
		var $list_holder = $('#lavatory_shape_list');
		$list_holder.html(code_list);

		// リンクの初期化
		ENGINE.Simulator.initTransitionLink($list_holder);

// console.log('moveLavatoryShape() - end.');
	},

	/**
	 * Lavatory / Shape パネルの表示
	 *
	 */
	moveLavatoryProduct: function(search_type, search_id) {
// console.log('moveLavatoryProduct() - start.');
// console.log('moveLavatoryProduct() : search : type[' + search_type + '][' + search_id + ']');

		var selected_shape = ENGINE.Simulator.condition['lavatory-shape'];

		var code_list   = "";

		// 製品データの取得
		var list = ENGINE.Simulator.searchProducts4Lavatory('lavatory-shape', selected_shape);

// console.log('moveLavatoryProduct() : show refine list');
// console.log(list);

		// 遷移先の判定
		var transition_link = 'faucet-series';
		// 水栓金具が選択されている場合は結果画面、選択されていない場合は水栓金具の選択フローへ
// console.log(ENGINE.Simulator.condition);
		var selected_faucet = ENGINE.Simulator.condition['faucet-product'];
		if (selected_faucet) {
			transition_link = 'result';
		}
		var product_image, product_id, product, product_image_name;
// console.log('moveLavatoryProduct() : transition link[' + transition_link + ']');

		code_list += '<h2 class="m_ttl__base m_rsp_mgb15"><small>' + ENGINE.Simulator.messages['lavatory_shape_' + selected_shape] + '</small></h2>'
		code_list += '<div class="m_col__large"><ul>';
		for(var i=0,max=list.length; i<max; i++) {
			code_list += '<li><a href="#lavatory-product" data-transition-link="' + transition_link + '" data-select-type="lavatory-product" data-select-id="' + list[i]["PRODUCT_ID"] + '">';
			// 製品画像
			product_id = list[i]["PRODUCT_ID"];
			product = ENGINE.Simulator.searchProductAt('lavatory-product', product_id);

			code_list += '<div class="m_col__img">' + ENGINE.Simulator.generateCodeProductImage4List('lavatory', product) + '</div>';
			// 品番
			code_list += '<div class="m_series__name"><p>' + list[i]["PRODUCT_ID"] + '</p></div>';

			// サイズの表示
			// code_list += '<div class="m_series__size"><ul class="m_list__inline">';
			// code_list += '<li>W' + list[i]["SIZE_W"] + ' ×</li>';
			// code_list += '<li>H' + list[i]["SIZE_H"] + ' ×</li>';
			// code_list += '<li>D' + list[i]["SIZE_D"] + '</li>';
			// code_list += '</ul></div>';
			code_list += '<div class="m_series__size">';
			code_list += 'W' + list[i]["SIZE_W"] + ' × ';
			code_list += 'H' + list[i]["SIZE_H"] + ' × ';
			code_list += 'D' + list[i]["SIZE_D"] + '';
			code_list += '</div>';

			// 技術アイコン、デザインアイコン
			code_list += ENGINE.Simulator.generateCode4IconList(list[i], true);

			code_list += '</a></li>';

		}
		code_list += '</ul></div>';

		var $list_holder = $('#lavatory_product_list');
		$list_holder.html(code_list);

		// リンクの初期化
		ENGINE.Simulator.initTransitionLink($list_holder);

// console.log('moveLavatoryProduct() - end.');
	},

	/**
	 * 結果画面の表示
	 *
	 */
	moveResult: function() {
// console.log('moveResult() - start.');
		// Faucet製品情報の取得
		var faucet_id = ENGINE.Simulator.condition['faucet-product'];
		var faucet_colour = ENGINE.Simulator.condition['faucet-colour'];

		// changeから再選択しようとして中断した場合の処理
		if ( (faucet_colour == '') && (ENGINE.Simulator.condition['faucet-colour-before']) ) {
			faucet_colour = ENGINE.Simulator.condition['faucet-colour-before'];
			ENGINE.Simulator.condition['faucet-colour-before'] = '';
		}

		// Lavatory製品情報の取得
		var lavatory_id = ENGINE.Simulator.condition['lavatory-product'];

		// 結果画面用コード（PC／SP共通）の取得
		var $result = $('#result_panel');
		var code_result = ENGINE.Simulator.generateCodeResult('m_result', faucet_id, faucet_colour, lavatory_id);

		$result.html(code_result);
		ENGINE.Simulator.initActionLink($result);
		ENGINE.Simulator.initTransitionLink($result);

		// スマホ用商品リストの表示
		var $sp_result = $('#sp_result_list');
		var code_result_sp = ENGINE.Simulator.generateCodeSelectedList('result');
		$sp_result.html(code_result_sp);

		ENGINE.Simulator.initActionLink($sp_result);
		ENGINE.Simulator.initTransitionLink($sp_result);

// console.log('moveResult() - end.');
	},

	/**
	 * 保存セット画面
	 *
	 */
	moveSaved: function(type, target_id) {
// console.log('moveSaved() - start.');
// console.log('moveSaved() : id[' + target_id + ']');

		var favorite = ENGINE.Simulator.getFavorite(target_id);

		if (favorite) {
			var id = favorite['id'];

			var code_result = ENGINE.Simulator.generateCodeSaved(favorite);

			var $target = $('#saved_result');
			$target.html(code_result);

			ENGINE.Simulator.initActionLink($target);
			ENGINE.Simulator.initTransitionLink($target);

			// 削除ボタン（画面上部）
			$('[data-action-link="delete-favorite-saved"]').data('select-id', target_id);

			// 左ナビの切り替え
			$('#favorite_nav_list4saved [data-transition-link="saved"]').removeClass('is_active');
			$('#favorite_nav_list4saved [data-transition-link="saved"][data-select-id="' + target_id + '"]').addClass('is_active');

			// Donwloadリンク
			$('[data-action-link="download-pdf-saved"]').data('select-id', target_id);
			// Shareリンク
			$('[data-action-link="open-share-saved"]').data('select-id', target_id);
			// chageリンクへのID設定
			$('[data-action-link="swap-favorite-product"]').data('select-id', target_id);

		} else {

			var code_result = '<p class="m_message">' + ENGINE.Simulator.messages['favarite_list_not_found'] + '</p>';

			var $target = $('#saved_result');
			$target.html(code_result);

		}

		// favoriteモーダルのCLOSE
		$('.js_favorite__close').triggerHandler('click');

// console.log('moveSaved() - end.');
	},
	/**
	 * 比較画面
	 *
	 */
	moveCompare: function() {
// console.log('moveCompare() - start.');

		var favorite_list = ENGINE.Simulator.getFavoriteList();
		var code = '';
		var id, faucet, lavatory, selected_faucet, selected_lavatory, selected_faucet_colour, datetime, faucet_product_image, lavatory_product_image, lavatory_shape, lavaroty_product_image_name;
		var code_product_image, code_product_name, code_icon_list, code_colour, colour_name;
		var total, product_price;


		if (favorite_list && (favorite_list.length > 0)) {

			for(var i=(favorite_list.length-1), min=0; i>=min; i--) {
				id = favorite_list[i]['id'];
				total = 0;

				datetime = favorite_list[i]['dt'];
				selected_faucet = favorite_list[i]['fid'];
				selected_lavatory = favorite_list[i]['lid'];
				selected_faucet_colour = favorite_list[i]['fc'];

				faucet    = ENGINE.Simulator.searchProductAt('faucet-product', selected_faucet);
				lavatory = ENGINE.Simulator.searchProductAt('lavatory-product', selected_lavatory);

// console.log('moveCompare() - favorite_list[' + i + ']');
// console.log(favorite_list[i]);

        code += '<li class="js_favorite__item is_show" data-favorite-id="' + id + '">';
        // 削除ボタン
        // code += '<div class="m_compare__delete m_balloon js_favorite__delete--piecesBtn">';
        code += '<div class="m_compare__delete m_balloon" data-action-link="hide-favorite-compare" data-select-type="id" data-select-id="' + id + '">';
        code += '<div class="m_compare__delete--icon"><span class="m_compare__delete--icon-inner"><i class="m_icon__cross"></i></span></div>';
        code += '<div class="m_compare__delete--cont"><p>' + ENGINE.Simulator.messages['delete_link'] + '</p></div>';
        code += '</div>';

				code += '<a href="#saved" data-transition-link="saved" data-select-type="saved" data-select-id="' + id + '">'
				// 製品名（すべて）
				code += '<div class="m_compare__name m_mgb15 m_pdt20"><p>' + selected_faucet + ' / ' + selected_lavatory + '</p></div>';
				// 保存日時
				code += '<time class="m_compare__date m_mgb10">' + datetime + '</time>';

				// 結果画像
				code_product_image = ENGINE.Simulator.generateCodeProductImage4Result(faucet, selected_faucet_colour, lavatory);
				code += '<div class="m_compare__img">' + code_product_image + '</div>';


				// [START] faucet情報
				code += '<div class="m_navi__area">';
				code += '<h2 class="m_ttl__small m_mgt10 m_mgb15 m_pdl15 m_pdr15 is-taL">' + ENGINE.Simulator.messages['faucet'] + '</h2>';
				// 製品名
				code_product_name = selected_faucet + ' (' + faucet['SERIES'] + ENGINE.Simulator.messages['category_series'] + ')';
				code += '<div class="m_compare__name m_mgb10"><p>' + code_product_name + '</p></div>';
				// アイコンリスト
				code_icon_list = ENGINE.Simulator.generateCode4IconList(faucet, false);
				code += '<ul class="m_list__inline m_list__icon m_pdl15 m_pdr15 is-taL">' + code_icon_list + '</ul>';


				// カラー
				colour_name = ENGINE.Simulator.messages['colour_' + selected_faucet_colour];
				code_colour  = '<div class="m_navi__colour--balloon-img is_' + selected_faucet_colour + '"></div>';
				code_colour += '<div class="m_navi__colour--balloon-txt"><p>' + colour_name + '</p></div>';
				code += '<div class="m_navi__colour--selected m_pdl15 m_pdr15">';
				code += '<div class="m_navi__colour--balloon-inner m_mgb0 js_nav_faucet_colour">';
				code += code_colour;
				code += '</div>';
				code += '</div>';

				// 金額
				if (ENGINE.Simulator.settings['price_flg']) {
					total += Number(faucet['PRICE']);
					product_price = ENGINE.SimulatorCommon.priceFormat(faucet['PRICE'], ENGINE.Simulator.settings);
					code += '<p class="m_navi__money is-taR m_pdl15 m_pdr15">' + product_price + '</p>';
					code += '<p class="m_navi__money--txt is-taR m_pdl15 m_pdr15">' + ENGINE.Simulator.messages['tax_include'] + '</p>';
				}

				code += '</div>';
				// [END] faucet情報


				// [START] lavatory情報
				code += '<div class="m_navi__area m_border-top__none">';
				code += '<h2 class="m_ttl__small m_mgt10 m_mgb15 m_pdl15 m_pdr15 is-taL">LAVATORY</h2>';

				// 製品名
				lavatory_shape = lavatory['SHAPE'];
				code_product_name = selected_lavatory + ' (' + ENGINE.Simulator.messages['lavatory_shape_' + lavatory_shape] + ')';
				code += '<div class="m_compare__name m_mgb10"><p>' + code_product_name + '</p></div>';

				// アイコンリスト
				code_icon_list = ENGINE.Simulator.generateCode4IconList(lavatory, false);
				code += '<ul class="m_list__inline m_list__icon m_pdl15 m_pdr15 is-taL">' + code_icon_list + '</ul>';

				// カラー
				code += '<div class="m_navi__colour--selected m_pdl15 m_pdr15">';
				code += '<div class="m_navi__colour--balloon-inner m_mgb0">';
				code += '<div class="m_navi__colour--balloon-img is_WHITE"></div>';
				code += '<div class="m_navi__colour--balloon-txt"><p>' + ENGINE.Simulator.messages['colour_W'] + '</p></div>';
				code += '</div>';
				code += '</div>';

				// 金額
				if (ENGINE.Simulator.settings['price_flg']) {
					total += Number(lavatory['PRICE']);
					product_price = ENGINE.SimulatorCommon.priceFormat(lavatory['PRICE'], ENGINE.Simulator.settings);
					code += '<p class="m_navi__money is-taR m_pdl15 m_pdr15">' + product_price + '</p>';
					code += '<p class="m_navi__money--txt is-taR m_pdl15 m_pdr15">' + ENGINE.Simulator.messages['tax_include'] + '</p>';
				}

				code += '</div>';
				// [END] lavatory情報


				// [START] 合計金額
				if (ENGINE.Simulator.settings['price_flg']) {
					code += '<div class="m_navi__total">';
					code += '<div class="m_navi__wrap">';
					code += '<h2 class="m_ttl__small is-color-base">' + ENGINE.Simulator.messages['total_amount'] + '</h2>';
					code += '<p class="m_navi__money is-fwB">' + ENGINE.SimulatorCommon.priceFormat(total, ENGINE.Simulator.settings) + '</p>';
					code += '</div>';
					code += '<p class="m_navi__money--txt is-taR">' + ENGINE.Simulator.messages['tax_include'] + '</p>';
					code += '</div>';
				}
				// [END] 合計金額

				code += '</a>';
        code += '</li>';

			}

			var $target = $('#favorite_list4compare');
			$target.html(code);

			$('[data-action-link="show-favorite-compare-all"]').show();

			ENGINE.Simulator.initTransitionLink($target);
			ENGINE.Simulator.initActionLink($target);

		} else {

			code = '<p class="m_message">' + ENGINE.Simulator.messages['favarite_list_not_found'] + '</p>';

			var $target = $('#favorite_list4compare');
			$target.html(code);

			$('[data-action-link="show-favorite-compare-all"]').hide();
		}

		// 左ナビ（m_nav is_compare）の初期化（チェックをつける）
		var $navCheckbox = $('#favorite_nav_list4compare li[data-select-id] input');
		$navCheckbox.prop('checked', true);


		// favoriteモーダルのCLOSE
		$('.js_favorite__close').triggerHandler('click');

// console.log('moveCompare() - end.');

	},


	//////////////////////////////////////////////////////////////////
	// [END] 画面遷移時の処理（シミュレータ固有）
	//////////////////////////////////////////////////////////////////


	//////////////////////////////////////////////////////////////////
	// [START] 各処理と連動した再描画系の処理（シミュレータ固有）
	//////////////////////////////////////////////////////////////////
	/**
	 * ステップフローの並び順変更
	 *
	 */
	setupFlowNavi: function(target_id) {
// console.log('setupFlowNavi() - start.');
// console.log('setupFlowNavi() : param : ' + target_id);

		// ステップフロー情報の取得（シミュレーション開始画面IDごとに異なる）
		var flow_list = ENGINE.Simulator.flow_list[target_id];

// console.log('setupFlowNavi() - flow_list.');
// console.log(flow_list);
		// ステップフローの並び替え
		if (flow_list) {
			for(var i=0,max=flow_list.length; i<max; i++) {
				var item_id = flow_list[i]['id'];
				var $item = ENGINE.Simulator.flow_nav['items'][item_id];

				// 表示非表示の切り替え
				if (flow_list[i]['show']) {
					$item.show();
				} else {
					$item.hide();
				}
				// リンクの非・アクティブ化
				ENGINE.Simulator.flow_nav['links'][item_id].addClass('is_inactive');

				ENGINE.Simulator.flow_nav['container'].append($item);
			}

			ENGINE.Simulator.flow_nav['first-step'] = target_id;
		}

// console.log('setupFlowNavi() - end.');
	},
	/**
	 * ステップフローの更新（Active / InActiveの切り替え）
	 *
	 */
	resetFlowNavi: function(target_id, current_id) {
// console.log('resetFlowNavi() - start.');
// console.log('resetFlowNavi() : target[' + target_id + ']' + ' current[' + current_id + ']');

		// 1つめの画面遷移の場合、ステップフローを更新する（ステップが変更になるため）
		if ((ENGINE.Simulator.panel_history_list.length == 1) || (current_id == 'top')) {
			ENGINE.Simulator.setupFlowNavi(target_id);
		}

		// Activeにするステップを取得
		var $target = ENGINE.Simulator.flow_nav['items'][target_id];
		if ($target) {
			// リセット
			ENGINE.Simulator.flow_nav['all-items'].removeClass('is_current');
			// Active化
			$target.addClass('is_current');

			// フローリストの位置調整
			var $holder = $('.m_flow');
			var $move   = ENGINE.Simulator.flow_nav['container'];

			var holder_pos = $holder.offset().left;
			var holder_w   = $holder.width();
			var target_pos = $target.offset().left;
			var target_w   = $target.width();
			var pos = 0;

			pos = (target_pos + $holder.scrollLeft()) - holder_pos - (holder_w - target_w) / 2;

// console.log('resetFlowNavi() : current pos[' + target_pos + '] move pos[' + $move.offset().left + '] move pos[' + $holder.scrollLeft() + '] holder pos[' + holder_pos + ']');
// console.log('resetFlowNavi() : current pos[' + target_w + '] holder pos[' + holder_w + ']');
// console.log('resetFlowNavi() : pos[' + pos + ']');
			if (pos > 0) {
// console.log('resetFlowNavi() : adjust');
				$holder.scrollLeft(pos);
			}

		}

		// リンクの有効化
		for (var id in ENGINE.Simulator.condition) {
			if (ENGINE.Simulator.condition[id] && ENGINE.Simulator.flow_nav['links'][id]) {
				ENGINE.Simulator.flow_nav['links'][id].removeClass('is_inactive');

				// colour選択が完了している場合
				if (id == 'faucet-colour') {
					ENGINE.Simulator.flow_nav['links']['faucet-select-colour'].removeClass('is_inactive');
				}
			}
		}


// console.log('resetFlowNavi() - end.');
	},
	/**
	 * ナビゲーションの再設定の処理
	 *
	 */
	refreshNavi: function(target_id) {
// console.log('refreshNavi() - start.');

		var code_navi = ENGINE.Simulator.generateCodeSelectedList(target_id);

		var $target = $('#nav_simulator');
		$target.html(code_navi);

		ENGINE.Simulator.initActionLink($target);
		ENGINE.Simulator.initTransitionLink($target);

// console.log('refreshNavi() - end.');
	},

	/**
	 * お気に入り一覧（左ナビ）の再描画
	 *
	 */
	refreshFavorite: function() {
// console.log('refreshFavorite() - start.');

		var favorite_list = ENGINE.Simulator.getFavoriteList();
		var count = favorite_list?favorite_list.length:0;

		// お気に入り件数の設定
		$('.js_favorite_count').html(count);
		if (count > 0) {
			$('.js_favorite__btn').removeClass('in-active');
		} else {
			$('.js_favorite__btn').addClass('in-active');
		}

		// お気に入りリスト（your plan list）の設定
// console.log('refreshFavorite() : favorite_list');
// console.log(favorite_list);
		var code_favorite_nav_list = '';
		var code_favorite_nav_list4compare = '';
		var code_favorite_nav_list4saved = '';

		if (favorite_list && (favorite_list.length > 0)) {
			code_favorite_nav_list = '';
			code_favorite_nav_list4compare = '';
			code_favorite_nav_list4saved = '';
			// for(var i=0, max=favorite_list.length; i<max; i++) {
			for(var i=(favorite_list.length-1), min=0; i>=min; i--) {
				code_favorite_nav_list += ENGINE.Simulator.generateCodeFavoriteItem4Navi('yourlist', favorite_list[i]);
				code_favorite_nav_list4compare += ENGINE.Simulator.generateCodeFavoriteItem4Navi('compare', favorite_list[i]);
				code_favorite_nav_list4saved += ENGINE.Simulator.generateCodeFavoriteItem4Navi('saved', favorite_list[i]);
			}

			if (code_favorite_nav_list) {
				code_favorite_nav_list = '<ul class="m_favorite__list">' + code_favorite_nav_list + '</ul>';
			}
			if (code_favorite_nav_list4compare) {
				code_favorite_nav_list4compare = '<ul class="m_model-col2__list">' + code_favorite_nav_list4compare + '</ul>';
			}
			if (code_favorite_nav_list4saved) {
				code_favorite_nav_list4saved = '<ul class="m_model-col2__list">' + code_favorite_nav_list4saved + '</ul>';
			}
		} else {
			code_favorite_nav_list = '<p class="m_message">' + ENGINE.Simulator.messages['favarite_list_not_found'] + '</p>';
			code_favorite_nav_list4compare = '<p class="m_message">' + ENGINE.Simulator.messages['favarite_list_not_found'] + '</p>';
			code_favorite_nav_list4saved = '<p class="m_message">' + ENGINE.Simulator.messages['favarite_list_not_found'] + '</p>';
		}

		// yourlistの設定
		var $favorite_nav_list = $('#favorite_nav_list');
		$favorite_nav_list.html(code_favorite_nav_list);
		// リンクの設定
		ENGINE.Simulator.initTransitionLink($favorite_nav_list);

		// compareの設定
		var $favorite_nav_list4compare = $('#favorite_nav_list4compare');
		$favorite_nav_list4compare.html(code_favorite_nav_list4compare);
		// Actionリンクの設定
		ENGINE.Simulator.initActionLink($favorite_nav_list4compare);

		// compareの設定
		var $favorite_nav_list4saved = $('#favorite_nav_list4saved');
		$favorite_nav_list4saved.html(code_favorite_nav_list4saved);
		// Actionリンクの設定
		// ENGINE.Simulator.initActionLink($favorite_nav_list4saved);
		ENGINE.Simulator.initTransitionLink($favorite_nav_list4saved);

// console.log('refreshFavorite() - end.');
	},

	/**
	 *
	 *
	 */
	refreshResultController: function() {

	},
	//////////////////////////////////////////////////////////////////
	// [END] 各処理と連動した再描画系の処理（シミュレータ固有）
	//////////////////////////////////////////////////////////////////



	//////////////////////////////////////////////////////////////////
	// [START] 操作系の処理（シミュレータ固有）
	//////////////////////////////////////////////////////////////////
	/**
	 * 色選択時の処理
	 *
	 */
	selectFaucetColour: function(select_type, select_id) {
// console.log('selectFaucetColour() - start.');

		if (select_id && (ENGINE.Simulator.condition[select_type] != select_id) ) {
			ENGINE.Simulator.condition[select_type] = select_id;
		}

		// 左ナビの選択色の切り替え
		var code_colour = '';
		var colour_name = ENGINE.Simulator.messages['colour_' + select_id];
		code_colour += '<div class="m_navi__colour--balloon-img is_' + select_id + '"></div>';
		code_colour += '<div class="m_navi__colour--balloon-txt"><p>' + colour_name + '</p></div>';
		$('.js_nav_faucet_colour').html(code_colour);

		// アクティブ・非アクティブ表示の制御
		$('.js_colour__check li').removeClass('is_active');
		var $current = $('.js_colour__check button[data-select-id="' + select_id + '"]');
		$current.parent().addClass('is_active');
// console.log('swapFaucetColour4Results() : $target[' + $current.length + ']');

		// 画像の切り替え
		var product_id = ENGINE.Simulator.condition['faucet-product'];
		var product = ENGINE.Simulator.vars.faucet_master[product_id];
		var code_product_image =  ENGINE.Simulator.generateCodeProductImage4List('faucet', product, select_id);
		$('#faucet_product_image').html(code_product_image);

// console.log('selectFaucetColour() - end.');
	},
	/**
	 * 色選択時の処理
	 *
	 */
	swapFaucetColour4Results: function(select_type, select_id) {
// console.log('swapFaucetColour4Results() - start.');

		if (select_id && (ENGINE.Simulator.condition[select_type] != select_id) ) {
			ENGINE.Simulator.condition[select_type] = select_id;
		}

		// 左ナビの選択色の切り替え
		var code_colour = '';
		var colour_name = ENGINE.Simulator.messages['colour_' + select_id];
		code_colour += '<div class="m_navi__colour--balloon-img is_' + select_id + '"></div>';
		code_colour += '<div class="m_navi__colour--balloon-txt"><p>' + colour_name + '</p></div>';

// console.log($('.js_nav_faucet_colour').length);
		var $selected_colour = $('.js_nav_faucet_colour');
		if ($selected_colour.length) {
			$selected_colour.html(code_colour);
		}

		// アクティブ・非アクティブ表示の制御
		$('.js_colour__check li').removeClass('is_active');
		var $current = $('.js_colour__check button[data-select-id="' + select_id + '"]');
		$current.parent().addClass('is_active');
// console.log('swapFaucetColour4Results() : $target[' + $current.length + ']');

		// 画像の切り替え
		var product_id = ENGINE.Simulator.condition['faucet-product'];
		var faucet_image = ENGINE.Simulator.settings['faucet_image'] + product_id + '_' + select_id + '.png';

		var $faucet = $('#result-faucet');
		// $faucet.attr('style', 'background-image: url(' + faucet_image + ');');
		$faucet.css('background-image', 'url(' + faucet_image + ')');

		// 設定ファイルで定義されている場合（品番により決定）
		var $faucet_upper = $('#result-faucet-upper');
// console.log('eeeeee');
// console.log($faucet_upper.length);
// console.log(ENGINE.Simulator.settings['faucet_separete']);
// console.log(product_id);
		if ( ($faucet_upper.length > 0) && ENGINE.Simulator.settings['faucet_separete'] && ENGINE.Simulator.settings['faucet_separete'][product_id]) {
			var faucet_upper_image = ENGINE.Simulator.settings['faucet_image'] + product_id + '_' + select_id + '_u.png';
// console.log('eeeeee - change');
// console.log(faucet_upper_image);

			$faucet_upper.css('background-image', 'url(' + faucet_upper_image + ')');
		}

		var $faucet_lever = $('#result-faucet-lever');
		if ($faucet_lever.length > 0) {
			var faucet_lever_image = ENGINE.Simulator.settings['faucet_image'] + 'zl_lever/zl_lever_' + select_id + '.png';
			// Lavatoryがsemi-reccessedの場合、角度違いのレバー画像を表示
			if ($faucet_lever.hasClass('is-lavatory-shape-semi_reccesed')) {
				var add_faucet_lever_image = '';
				var lavatory_id = ENGINE.Simulator.condition['lavatory-product'];
				if (ENGINE.Simulator.settings['faucet_lever_image'] && ENGINE.Simulator.settings['faucet_lever_image'][lavatory_id]) {
					add_faucet_lever_image = '_' + ENGINE.Simulator.settings['faucet_lever_image'][lavatory_id];
				}
				faucet_lever_image = ENGINE.Simulator.settings['faucet_image'] + 'zl_lever/zl_lever_' + select_id + add_faucet_lever_image + '.png';
			}


			// $faucet_lever.attr('style', 'background-image: url(' + faucet_lever_image + ');');
			$faucet_lever.css('background-image', 'url(' + faucet_lever_image + ')');
		}

// console.log('swapFaucetColour4Results() - end.');
	},
	/**
	 * Shareモーダルの表示
	 *
	 */
	openShare: function() {

		var total = 0;

		var selected_faucet = ENGINE.Simulator.condition['faucet-product'];
		var selected_faucet_colour = ENGINE.Simulator.condition['faucet-colour'];
		var selected_lavatory = ENGINE.Simulator.condition['lavatory-product'];


		var code = ENGINE.Simulator.generateCodeShareModal(selected_faucet, selected_faucet_colour, selected_lavatory);
		var $target = $('#share_result');
		$target.html(code);

		ENGINE.Simulator.initActionLink($target);
		ENGINE.Simulator.initTransitionLink($target);


		// Copy用にURLをセット
		var url = ENGINE.Simulator.getResultURL();
// console.log('copy url : ' + $('#copy_url').length);
// console.log('copy url : ' + url);
		$('#copy_url').val(url);

		$('.js_modal').fadeIn();

	},
	/**
	 * Shareモーダルの表示（お気に入りから）
	 *
	 */
	openShare4Saved: function(type, target_id) {

// console.log('openShare4Saved() - start : ' + type + ' :: ' + target_id);
		var total = 0;

		var favorite = ENGINE.Simulator.getFavorite(target_id);

		var selected_faucet = favorite['fid'];
		var selected_faucet_colour = favorite['fc'];
		var selected_lavatory = favorite['lid'];

		var code = ENGINE.Simulator.generateCodeShareModal(selected_faucet, selected_faucet_colour, selected_lavatory);
		var $target = $('#share_result');
		$target.html(code);

		ENGINE.Simulator.initActionLink($target);
		ENGINE.Simulator.initTransitionLink($target);

		// Copy用にURLをセット
		var url = ENGINE.Simulator.getResultURL();
		$('#copy_url').val(url);

		$('.js_modal').fadeIn();

	},
	/**
	 * 保存画面からお気に入りを削除
	 *
	 */
	deleteFavoriteSaved: function(select_type, select_id) {
// console.log('deleteFavoriteSaved() - start.');
// console.log('deleteFavoriteSaved() : target[' + select_id + ']');

		// お気に入り情報の削除
		var next_id = ENGINE.Simulator.deleteFavorite(select_id);

		// 削除後に取得できたIDのお気に入り情報を表示
		// ENGINE.Simulator.moveSaved('saved', next_id);
		// 削除後、TOPへ戻すよう修正
		// ENGINE.Simulator.moveTop();
		ENGINE.Simulator.terminateTransitionFunc('saved', 'top');

// console.log('deleteFavoriteSaved() - end.');
	},
	/**
	 * 比較画面から選択されたプランを非表示にする
	 *
	 */
	hideFavoriteCompare: function(select_type, select_id) {
// console.log('hideFavoriteCompare() - start.');
// console.log('hideFavoriteCompare() : target[' + select_id + ']');

		var $navCheckbox = $('#favorite_nav_list4compare li[data-select-id="' + select_id + '"] input');
		var $item = $('#favorite_list4compare li[data-favorite-id="' + select_id + '"]');

// console.log($navCheckbox.length);
// console.log($item.length);

		$navCheckbox.prop('checked', false);
		$item.removeClass('is_show');

		// お気に入り情報の削除
		// ENGINE.Simulator.deleteFavorite(select_id);

		// var $target = $('[data-action-link="delete-favorite-compare"][data-select-id="' + select_id + '"]');
		// $target.parent().remove();

// console.log('hideFavoriteCompare() - end.');
	},
	/**
	 * 比較画面から選択されたプランを非表示にする
	 *
	 */
	swapFavoriteCompare: function(select_type, select_id) {
// console.log('swapFavoriteCompare() - start.');
// console.log('swapFavoriteCompare() : target[' + select_id + ']');

		var $navCheckbox = $('#favorite_nav_list4compare li[data-select-id="' + select_id + '"] input');
		var $item = $('#favorite_list4compare li[data-favorite-id="' + select_id + '"]');

// console.log($navCheckbox.length);
// console.log($item.length);

		if ($navCheckbox.prop('checked')) {
			$navCheckbox.prop('checked', false);
			$item.removeClass('is_show');
		} else {
			$navCheckbox.prop('checked', true);
			$item.addClass('is_show');
		}


// console.log('swapFavoriteCompare() - end.');
	},
	/**
	 * 比較画面から選択されたプランを非表示にする
	 *
	 */
	showFavoriteCompareAll: function() {
// console.log('showFavoriteCompareAll() - start.');

		var $navCheckbox = $('#favorite_nav_list4compare li[data-select-id] input');
		var $item = $('#favorite_list4compare li[data-favorite-id]');

// console.log($navCheckbox.length);
// console.log($item.length);

		$navCheckbox.prop('checked', true);
		$item.addClass('is_show');

// console.log('showFavoriteCompareAll() - end.');
	},
	/**
	 * お気に入りの保存
	 *
	 */
	addFavorite: function($link) {
		if ($link.hasClass('is-done')) {
			return false;
		}

		var now = new Date();

		var id = now.getTime();
		var datetime_y = now.getFullYear();
		var datetime_m = ENGINE.SimulatorCommon.zeroPadding((now.getMonth() + 1), 2);
		var datetime_d = ENGINE.SimulatorCommon.zeroPadding(now.getDate(), 2);
		var datetime_h = ENGINE.SimulatorCommon.zeroPadding(now.getHours(), 2);
		var datetime_i = ENGINE.SimulatorCommon.zeroPadding(now.getMinutes(), 2);

		var disp_datetime = datetime_y + '/' + datetime_m + '/' + datetime_d + ' ' + datetime_h + ':' + datetime_i;

		var selected_faucet        = ENGINE.Simulator.condition['faucet-product'];
		var selected_faucet_colour = ENGINE.Simulator.condition['faucet-colour'];
		var selected_lavatory     = ENGINE.Simulator.condition['lavatory-product'];

		// var faucet = ENGINE.Simulator.searchProductAt('faucet-product', selected_faucet);
		// var lavatory = ENGINE.Simulator.searchProductAt('lavatory-product', selected_lavatory);

		var params = {
			'id':  id,
			'dt':  disp_datetime,
			'fid': selected_faucet,
			'fc':  selected_faucet_colour,
			'lid': selected_lavatory,
		};

		var favorite_list = ENGINE.Simulator.getFavoriteList();

		if (favorite_list) {
			if (favorite_list.length >= 10) {
				// 先頭要素を削除
				favorite_list.shift();
			}
		} else {
			favorite_list = [];
		}
		favorite_list.push(params);
		$.cookie(ENGINE.Simulator.settings['cookie_id'], favorite_list, {expires: ENGINE.Simulator.settings['cookie_expired']});

		$link.addClass('is-done');

		ENGINE.Simulator.refreshFavorite();
	},

	/**
	 * 保存されているお気に入りデータを取得
	 *
	 */
	getFavoriteList: function() {
		var result = false;
		var favorite = $.cookie(ENGINE.Simulator.settings['cookie_id']);
		if (favorite) {
			result = favorite;
		}

		return result;
	},
	/**
	 * 保存されているお気に入りデータを取得
	 *
	 */
	getFavorite: function(target_id) {
		var favorite = false;
		var favorite_list = ENGINE.Simulator.getFavoriteList();

		if (favorite_list && (favorite_list.length > 0)) {
			var id;
			for(var i=0, max=favorite_list.length; i<max; i++) {
				id = favorite_list[i]['id'];
				if (id == target_id) {
					favorite = favorite_list[i];
					break;
				}
			}
		}

		return favorite;
	},
	/**
	 * 保存されているお気に入りデータの削除
	 *
	 */
	deleteFavorite: function(id) {
		var next_id = false;
		var favorite_list = ENGINE.Simulator.getFavoriteList();
		var new_favorite_list = [];
		if (favorite_list) {
			for(var i=0,max=favorite_list.length; i<max; i++) {
				if (favorite_list[i]['id'] != id) {
					new_favorite_list.push(favorite_list[i]);
				}
			}
			$.cookie(ENGINE.Simulator.settings['cookie_id'], new_favorite_list, {expires: ENGINE.Simulator.settings['cookie_expired']});
		}

		ENGINE.Simulator.refreshFavorite();

		if (new_favorite_list.length > 0) {
			next_id = new_favorite_list[0]['id'];
		}

		return next_id;
	},
	/**
	 * お気に入り画面からの商品変更
	 *
	 */
	 swapFavoriteProduct: function(select_type, select_id) {
// console.log('swapFavoriteProduct() - start.');

// console.log('swapFavoriteProduct() - select id : ' + select_id);
// console.log('swapFavoriteProduct() - select type : ' + select_type);

		var favorite = ENGINE.Simulator.getFavorite(select_id);

// console.log('swapFavoriteProduct() - condition');
// console.log(ENGINE.Simulator.condition);
// console.log('swapFavoriteProduct() - favorite');
// console.log(favorite);

		if (favorite) {
// console.log('swapFavoriteProduct() - found!');

			var faucet_id = favorite['fid'];
			var lavatory_id = favorite['lid'];
			var faucet_colour = favorite['fc'];

			var faucet    = ENGINE.Simulator.searchProductAt('faucet-product', faucet_id);
			var lavatory = ENGINE.Simulator.searchProductAt('lavatory-product', lavatory_id);

			ENGINE.Simulator.condition['faucet-product']    = faucet_id;
			ENGINE.Simulator.condition['faucet-series']     = faucet['SERIES'];
			ENGINE.Simulator.condition['faucet-colour']     = faucet_colour;
			ENGINE.Simulator.condition['lavatory-product'] = lavatory_id;
			ENGINE.Simulator.condition['lavatory-shape']   = lavatory['SHAPE'];

// console.log('swapFavoriteProduct() - move func');

			if (ENGINE.Simulator.func['move-' + select_type]) {

				// 画面遷移処理
				ENGINE.Simulator.func['move-' + select_type]();

				// 画面遷移処理の最終処理
				ENGINE.Simulator.terminateTransitionFunc(ENGINE.Simulator.active_panel_id, select_type);
			}

		}

// console.log('swapFavoriteProduct() - end.');
	 },


	/**
	 *
	 *
	 */
	copyResultURL: function() {
// console.log('copyResultURL() - start.');

    //elmはtextareaノード
    var elm = $("#copy_url")[0];

    //select()でtextarea内の文字を選択
    elm.select();

    //select()でtextarea内の文字を選択
    elm.select();

    //rangeでtextarea内の文字を選択
    var range = document.createRange();
    range.selectNodeContents(elm);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    elm.setSelectionRange(0, 999999);

    //execCommandを実施
    document.execCommand("copy");

// console.log('copyResultURL() - end.');
	},
	/**
	 *
	 *
	 */
	getResultURL: function() {
		// URLパラメータの取得
		var qstr = ENGINE.Simulator.generateURLParameter(ENGINE.Simulator.condition);
		var url  = window.location.href + '';

		if (url.indexOf('?') >= 0) {
			var parts = url.split('?');
			url = parts[0];
		}
		url = url + qstr + '&p=result';

		return url;
	},
	/**
	 *
	 *
	 */
	shareResultURL: function(select_type, select_id) {
// console.log('shareResultURL() - start.');
// console.log('shareResultURL() : type[' + select_type + '] id[' + select_id + ']');

		var result_url = ENGINE.Simulator.getResultURL();

		var share_url = (ENGINE.Simulator.settings['sns_url'] && ENGINE.Simulator.settings['sns_url'][select_id])?ENGINE.Simulator.settings['sns_url'][select_id]:'';
		var share_text = ENGINE.Simulator.messages['sns_text_faucet-lavatory'];
// console.log('text : ' + share_text);
		if (share_url) {
			share_url = share_url.split('{{url}}').join(result_url);
			if (share_text) {
				share_url = share_url.split('{{text}}').join(share_text);
			}

// console.log(share_url);

			window.open(share_url);
		}
// console.log('shareResultURL() - end.');
	},
	/**
	 *
	 *
	 */
	downloadPDF: function() {
// console.log('downloadPDF() - start.');

		var qstr = ENGINE.Simulator.generateURLParameter(ENGINE.Simulator.condition);
		var download_url = (ENGINE.Simulator.settings['api_url'] && ENGINE.Simulator.settings['api_url']['faucet']['download'])?ENGINE.Simulator.settings['api_url']['faucet']['download']:'';

		if (download_url) {
			download_url = download_url + qstr;

// console.log(download_url);

			window.open(download_url);
		}
// console.log('downloadPDF() - end.');
	},
	/**
	 *
	 *
	 */
	downloadPDF4Saved: function(type, favarite_id) {
// console.log('downloadPDF4Saved() - start.');

		var favorite = ENGINE.Simulator.getFavorite(favarite_id);
// console.log(favarite_id);
// console.log(favorite);
		var params = {
			'lavatory-product' : favorite['lid'],
			'faucet-product'   : favorite['fid'],
			'faucet-colour'    : favorite['fc'],
		};
		var qstr = ENGINE.Simulator.generateURLParameter(params);

		var download_url = (ENGINE.Simulator.settings['api_url'] && ENGINE.Simulator.settings['api_url']['faucet']['download'])?ENGINE.Simulator.settings['api_url']['faucet']['download']:'';

		if (download_url) {
			download_url = download_url + qstr;

// console.log(download_url);

			window.open(download_url);
		}
// console.log('downloadPDF4Saved() - end.');
	},
	//////////////////////////////////////////////////////////////////
	// [END] 操作系の処理（シミュレータ固有）
	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// [START] HTMLコード生成処理（シミュレータ固有）
	//////////////////////////////////////////////////////////////////
	/**
	 * 画像パスの取得
	 *
	 */
	judgeResultImage: function(faucet, faucet_colour, lavatory, is_list) {
// console.log('judgeResultImage - start.');

		var faucet_lever_image = '';
		var faucet_upper_image = '';
		var faucet_image       = '';
		var lavatory_image     = '';
		var base_image         = '';

		// Faucet製品情報の取得
		var faucet_id       = (faucet && faucet['PRODUCT_ID'])?faucet['PRODUCT_ID']:'';
		var faucet_series   = (faucet && faucet['SERIES'])?faucet['SERIES']:'';
		var faucet_shape    = (faucet && faucet['SHAPE'])?faucet['SHAPE']:'';
		var faucet_category = (faucet && faucet['CATEGORY_1'])?faucet['CATEGORY_1']:'';

		// Lavatory製品情報の取得
		var lavatory_id    = (lavatory && lavatory['PRODUCT_ID'])?lavatory['PRODUCT_ID']:'';
		var lavatory_shape = (lavatory && lavatory['SHAPE'])?lavatory['SHAPE']:'';

// console.log('judgeResultImage - params.');
// console.log('faucet_id : ' + faucet_id);
// console.log('faucet_colour : ' + faucet_colour);
// console.log('faucet_series : ' + faucet_series);
// console.log('faucet_shape : ' + faucet_shape);
// console.log('faucet_category : ' + faucet_category);
// console.log('lavatory_id : ' + lavatory_id);
// console.log('lavatory_shape : ' + lavatory_shape);

		// faucet製品画像パスの取得
		if (faucet && faucet_colour) {
			faucet_image    = ENGINE.Simulator.settings['faucet_image'] + faucet_id + '_' + faucet_colour + '.png';

			// 設定ファイルで定義されている場合（品番により決定）
			if (ENGINE.Simulator.settings['faucet_separete'] && ENGINE.Simulator.settings['faucet_separete'][faucet_id]) {
				faucet_upper_image = ENGINE.Simulator.settings['faucet_image'] + faucet_id + '_' + faucet_colour + '_u.png';
			}

			// ZLレバー画像の取得
			if ( (faucet_series == 'ZL') && ((faucet_shape=='single_w_popup') || (faucet_shape=='single_wo_popup')) ) {
				if (is_list) {
					faucet_lever_image = ENGINE.Simulator.settings['faucet_image'] + 'zl_lever/zl_lever_R_' + faucet_colour + '.png';
				} else {
					var add_faucet_lever_image = '';
					// Lavatoryがsemi-reccessedの場合、角度違いのレバー画像を表示
					if (lavatory && (lavatory_shape == 'semi_reccesed')) {
// console.log(lavatory_id);
// console.log(ENGINE.Simulator.settings['faucet_lever_image']);
						if (ENGINE.Simulator.settings['faucet_lever_image'] && ENGINE.Simulator.settings['faucet_lever_image'][lavatory_id]) {
							add_faucet_lever_image = '_' + ENGINE.Simulator.settings['faucet_lever_image'][lavatory_id];
						}
					}
// console.log(add_faucet_lever_image);
					faucet_lever_image = ENGINE.Simulator.settings['faucet_image'] + 'zl_lever/zl_lever_' + faucet_colour + add_faucet_lever_image + '.png';
				}
			}
		}

		// Lavatory製品画像パスの取得
		if (lavatory) {
			var is_separate_counter = (lavatory && lavatory['IS_SEPARETE_COUNTER'])?true:false;

			var lavatory_image_add = '';
			if (lavatory['IS_CHANGE_SERIES']) {
				if (faucet['SERIES_CATEGORY'] == 'L') {
					lavatory_image_add = '_L';
				}
			}
			// 洗面器がunderと、水栓金具がwallmoutかつshortの組み合わせの場合、洗面器画像を変える
			// 20.12.01 under以外（under / vassel inset / galalato / selfrimmingも対応）
			// if ( (lavatory_shape == 'under') && (faucet_shape == 'wallmount') && (faucet_category == 'short') ) {
			var is_change_counter_short = false;
			var is_counter_none = false;
			if ( ( (lavatory_shape == 'under') || (lavatory_shape == 'vessel_outset') || (lavatory_shape == 'self_rimming') || (lavatory_shape == 'semi_reccesed') || (lavatory_shape == 'galalato') )  && (faucet_shape == 'wallmount') && (faucet_category == 'short') ) {
				lavatory_image_add += '_short';
				is_change_counter_short = true;

				// semi reccesed + shortの場合はカウンター付き洗面器のため、背景を変更する
				if (lavatory_shape == 'semi_reccesed') {
					is_counter_none = true;
				}
			}

			// Lavagoryの場合品番に#が使用されているものがあるためファイル名変換を行う
			var lavaroty_product_image_name = ENGINE.Simulator.converProductID2URL(lavatory_id);
			lavatory_image = ENGINE.Simulator.settings['lavatory_image'] + lavaroty_product_image_name + lavatory_image_add + '.png';

			// 背景画像の取得
			base_image = 'wall_only.png';
			if ( (lavatory_shape == 'vessel_outset') || (lavatory_shape == 'galalato') || is_separate_counter) {
				base_image  = 'wall_counter.png';
				if (is_change_counter_short) {
					base_image  = 'wall_counter_short.png';
				}

				if (!is_counter_none && (lavatory_shape == 'semi_reccesed')) {
					base_image  = 'wall_counter_semi_reccesed.png';
				} else if (is_counter_none) {
					base_image = 'wall_only.png';
				}
			}
			base_image = ENGINE.Simulator.settings['common_image'] + base_image;
		}


// console.log('judgeResultImage - end.');

		return {
			'faucet_lever_image' : faucet_lever_image,
			'faucet_upper_image' : faucet_upper_image,
			'faucet_image'       : faucet_image,
			'lavatory_image'     : lavatory_image,
			'base_image'         : base_image,
		};

	},
	/**
	 * 一覧ページ用製品画像（パーツのみ）
	 *
	 */
	generateCodeProductImage4List: function(product_type, product, colour) {
		var code = '';
		var code_before_image = '';
		var code_bg_image = '';

		var cls = 'is_parts_only is_' + product_type;
		var cls_img = '';
		var is_outset, is_separate_counter, bg_image, product_image, shape, series, series_cat, category1;

// console.log(product);

		// 形状
		shape = (product && product['SHAPE'])?product['SHAPE']:'';
		// シリーズカテゴリ
		series_cat = (product && product['SERIES_CATEGORY'])?product['SERIES_CATEGORY']:'';
		// シリーズ
		series = (product && product['SERIES'])?product['SERIES']:'';
		// カテゴリ
		category1 = (product && product['CATEGORY_1'])?product['CATEGORY_1']:'';

		// 画像にclassをセット
		if (shape) {
			cls_img += ' is_' + shape;
		}
		if (series_cat) {
			cls_img += ' is_' + series_cat;
		}
		if (category1) {
			cls_img += ' is_' + category1;
		}

		// 商品タイプによる制御
		if (product_type == 'lavatory') {

			// カウンターが分離されているか
			is_separate_counter = product['IS_SEPARETE_COUNTER'];

			// outsetかどうか（画像の重ね順）
			// Shapeがvessel_outset、galalato以外の場合、カウンターあり画像のためinset / outset に関わらず、金具が上になる (inset扱いとする)
			is_outset = (product && (product['CATEGORY_2'] == 'outset') && ((shape == 'vessel_outset') || (shape == 'galalato') || ( ((shape == 'self_rimming') || (shape == 'semi_reccesed')) && is_separate_counter)))?true:false;
			// is_outset = (product && (product['CATEGORY_2'] == 'outset') && ((shape == 'vessel_outset') || (shape == 'galalato') || ( (shape == 'semi_reccesed') && is_separate_counter)))?true:false;

			if (is_outset) {
				cls += ' is_faucet_outset';
			}

			// 画像パス情報の取得
			var image_info = ENGINE.Simulator.judgeResultImage(false, false, product);
// console.log('image info (lavagory) for generateCodeProductImage4List');
// console.log('product_id : ' + product['PRODUCT_ID']);
// console.log(image_info);

			// 製品画像の取得
			product_image = image_info['lavatory_image'];
			// 背景画像の取得
			bg_image = image_info['base_image'];

			code_bg_image = '<img src="' + bg_image + '" class="m_product_img__image is_counter" alt="">';

		} else if (product_type == 'faucet') {

			// 画像パス情報の取得
			var image_info = ENGINE.Simulator.judgeResultImage(product, colour, false, true);

// console.log('image info (faucet) for generateCodeProductImage4List');
// console.log('product_id : ' + product['PRODUCT_ID']);
// console.log(image_info);

			// 製品画像の取得
			product_image = image_info['faucet_image'];

			// ZLシリーズの場合、レバーを表示する
			if (image_info['faucet_lever_image']) {
				code_before_image = '<img src="' + image_info['faucet_lever_image'] + '" class="m_product_img__image is_faucet is_faucet_lever ' + cls_img + '" alt="">';

			}
		}

		code += '<div class="m_product_img ' + cls + '"><p class="m_product_img__inner">';
		code += code_before_image;
		code += '<img src="' + product_image + '" class="m_product_img__image is_' + product_type + ' ' + cls_img + '" alt="">';
		code += code_bg_image;
		code += '</p></div>';

		return code;
	},
	/**
	 * 結果用製品画像（favorite、Shareなどで使用する組み合わせ画像）
	 *
	 */
	generateCodeProductImage4Result: function(faucet, faucet_colour, lavatory) {

		var code = '';

		var faucet_id       = (faucet && faucet['PRODUCT_ID'])?faucet['PRODUCT_ID']:'';
		var faucet_series   = (faucet && faucet['SERIES'])?faucet['SERIES']:'';
		var faucet_shape    = (faucet && faucet['SHAPE'])?faucet['SHAPE']:'';
		var faucet_category = (faucet && faucet['CATEGORY_1'])?faucet['CATEGORY_1']:'';

		var lavatory_id    = (lavatory && lavatory['PRODUCT_ID'])?lavatory['PRODUCT_ID']:'';
		var lavatory_shape = (lavatory && lavatory['SHAPE'])?lavatory['SHAPE']:'';


		// カウンターが分離されているか
		var is_separate_counter = (lavatory && lavatory['IS_SEPARETE_COUNTER'])?true:false;

		// outsetかどうか（画像の重ね順）
		// Shapeがvessel_outset、galalato以外の場合、カウンターあり画像のためinset / outset に関わらず、金具が上になる (inset扱いとする)
		var is_outset = (lavatory && (lavatory['CATEGORY_2'] == 'outset') && ((lavatory_shape == 'vessel_outset') || (lavatory_shape == 'galalato') || ( ((lavatory_shape == 'self_rimming') || (lavatory_shape == 'semi_reccesed')) && is_separate_counter)))?true:false;
		// var is_outset = (lavatory && (lavatory['CATEGORY_2'] == 'outset') && ((lavatory_shape == 'vessel_outset') || (lavatory_shape == 'galalato') || ( (lavatory_shape == 'semi_reccesed') && is_separate_counter)))?true:false;

		// Faucetがwallmountの場合、outset扱いを解除（faucetが１番上になるよう制御）
		if (faucet && (faucet_shape == 'wallmount')) {
			is_outset = false;
		}

		var cls = '';
		if (is_outset) {
			cls = 'is_faucet_outset';
		}


		// 各種画像パスの取得
		var image_info = ENGINE.Simulator.judgeResultImage(faucet, faucet_colour, lavatory);
// console.log('image info for generateCodeProductImage4Result');
// console.log(image_info);
		var faucet_image   = image_info['faucet_image'];
		var lavatory_image = image_info['lavatory_image'];

		// 背景（カウンターありかどうか）
		var base_image    = image_info['base_image'];
		var code_bg_image = '<img src="' + base_image + '" class="m_product_img__image is_counter" alt="">';

		// FaucetのZLシリーズの場合、レバー画像を追加
		var code_faucet_lever_image = '';
		// if (faucet && (faucet_series == 'ZL') && faucet_colour) {
		if (faucet && (faucet_series == 'ZL') && faucet_colour && ((faucet_shape=='single_w_popup') || (faucet_shape=='single_wo_popup')) ) {

			var faucet_laver_image = image_info['faucet_lever_image'];

			var faucet_lever_pos = ENGINE.Simulator.getFaucetLeverPosition(faucet_id, false, lavatory_id, false);

			// レバー画像は、1200px × 1200pxの中心に配置されている（ハンドルの先端が中心に来る）ので調整する
			var calc_pos_left = faucet_lever_pos['pos_left'] - 50;
			var calc_pos_top  = faucet_lever_pos['pos_top'] - 50;

			// var faucet_lever_pos_style = ' transform: translate3d(' + calc_pos_left + '%, ' + calc_pos_top + '%, 0);';
			var faucet_lever_pos_style = ' margin-left: ' + calc_pos_left + '%; margin-top:' + calc_pos_top + '%;';

			code_faucet_lever_image = '<img src="' + faucet_laver_image + '" class="m_product_img__image is_faucet is_faucet_lever" style="' + faucet_lever_pos_style + '" alt="">';
		}

		// faucet 上部画像の表示
		var code_faucet_upper_image = '';
		var faucet_upper_image = image_info['faucet_upper_image'];
		if (faucet_upper_image) {
			code_faucet_upper_image += '<img src="' + faucet_upper_image + '" class="m_product_img__image is_faucet is_faucet_upper" alt="">';
		}

		// Faucetの位置の取得（wallmountの場合位置をずらす必要あり）
		var faucet_pos = ENGINE.Simulator.getFaucetPosition(faucet_shape, faucet_series, lavatory_shape, lavatory_id, lavatory['SIZE_D']);
		var faucet_pos_style = '';
		if (faucet_pos != 0) {
			// css（transform）で使える位置に変更
			faucet_pos = faucet_pos * (-1) * 100 - 50;
			faucet_pos_style = ' transform: translate3d(-50%, ' + faucet_pos + '%, 0);';
			faucet_pos_style = ' style="' + faucet_pos_style + '"';
		}

		code += '<div class="m_product_img ' + cls + '"><p class="m_product_img__inner">';
		code += code_faucet_upper_image + code_faucet_lever_image;
		code += '<img src="' + faucet_image + '" class="m_product_img__image is_faucet" ' + faucet_pos_style + ' alt="">';
		code += '<img src="' + lavatory_image + '" class="m_product_img__image is_lavatory" alt="">';
		code += code_bg_image;
		code += '</p></div>';

		return code;
	},
	/**
	 * 結果画像用HTMLコードの生成
	 *
	 */
	generateCodeResultImage: function(stage_id, faucet_id, faucet_colour, lavatory_id) {
		var code = '';
		var cls_stage = '';

		// Faucet製品情報の取得
		var faucet = ENGINE.Simulator.searchProductAt('faucet-product', faucet_id);
		var faucet_series = faucet['SERIES'];
		var faucet_shape  = (faucet && faucet['SHAPE'])?faucet['SHAPE']:'';
		var faucet_category = (faucet && faucet['CATEGORY_1'])?faucet['CATEGORY_1']:'';

		// Lavatory製品情報の取得
		var lavatory = ENGINE.Simulator.searchProductAt('lavatory-product', lavatory_id);
		var lavatory_shape = (lavatory && lavatory['SHAPE'])?lavatory['SHAPE']:'';
// console.log(lavatory);
// console.log(faucet);

		// カウンターが分離されているか
		var is_separate_counter = (lavatory && lavatory['IS_SEPARETE_COUNTER'])?true:false;

		// outsetかどうか（画像の重ね順）
		// Shapeがvessel_outset、galalato以外の場合、カウンターあり画像のためinset / outset に関わらず、金具が上になる (inset扱いとする)
		var is_outset = (lavatory && (lavatory['CATEGORY_2'] == 'outset') && ((lavatory_shape == 'vessel_outset') || (lavatory_shape == 'galalato') || ( ((lavatory_shape == 'self_rimming') || (lavatory_shape == 'semi_reccesed')) && is_separate_counter)))?true:false;
		// var is_outset = (lavatory && (lavatory['CATEGORY_2'] == 'outset') && ((lavatory_shape == 'vessel_outset') || (lavatory_shape == 'galalato') || ( (lavatory_shape == 'semi_reccesed') && is_separate_counter)))?true:false;

// console.log('is-separate  : ' + is_separate_counter);
// console.log('category  : ' + lavatory['CATEGORY_2']);
// console.log('shape     : ' + lavatory_shape);
// console.log('is-outset : ' + is_outset);

		// Faucetがwallmountの場合、outset扱いを解除（faucetが１番上になるよう制御）
		if (faucet && (faucet['SHAPE'] == 'wallmount')) {
			is_outset = false;
		}

		if (is_outset) {
			cls_stage = 'is_faucet_outset';
		}


		code += '<div class="m_result__inner js-stage ' + cls_stage + '"><div class="m_result__faucet_inner">';

		// 各種画像パスの取得
		var image_info = ENGINE.Simulator.judgeResultImage(faucet, faucet_colour, lavatory);
// console.log('image info for generateCodeResultImage');
// console.log(image_info);
		var faucet_image   = image_info['faucet_image'];
		var lavatory_image = image_info['lavatory_image'];
		var base_image     = image_info['base_image'];;

		// FaucetがZLシリーズの場合、レバーを表示する
		var faucet_lever_image = '';
		var cls_faucet_lever   = '';
		if (faucet_colour && (faucet_series == 'ZL') && ((faucet_shape=='single_w_popup') || (faucet_shape=='single_wo_popup')) ) {
			faucet_lever_image = image_info['faucet_lever_image'];
			cls_faucet_lever = (lavatory_shape)?('is-lavatory-shape-' + lavatory_shape):'';
		}

		// Faucetの位置の取得（wallmountの場合位置をずらす必要あり）
		var faucet_pos = ENGINE.Simulator.getFaucetPosition(faucet_shape, faucet_series, lavatory_shape, lavatory_id, lavatory['SIZE_D']);
		var faucet_pos_style = '';
		if (faucet_pos != 0) {
			// css（transform）で使える位置に変更 ※left top基準
			// faucet_pos = faucet_pos * (-1) * 100 - 50;
			faucet_pos = faucet_pos * (-1) * 100;
			faucet_pos_style = ' transform: translate3d(0%, ' + faucet_pos + '%, 0);';
			// faucet_pos_style = ' margin-top: ' + faucet_pos + '%';
		}

		// faucet 上部画像の表示
		var faucet_upper_image = image_info['faucet_upper_image'];
		if (faucet_upper_image) {
			code += '<div class="m_result__item is-faucet is_faucet_upper" style="background-image: url(' + faucet_upper_image + ');" id="result-faucet-upper"></div>';
		}

		// faucet レバーの表示
		if (faucet_lever_image) {
			var faucet_lever_pos = ENGINE.Simulator.getFaucetLeverPosition(faucet_id, false, lavatory_id, false);

			var faucet_lever_pos_style = '';
			if (faucet_lever_pos) {

// console.log(faucet_lever_pos);
				// レバー画像は、1200px × 1200pxの中心に配置されている（ハンドルの先端が中心に来る）ので調整する
				var calc_pos_left = faucet_lever_pos['pos_left'] - 50;
				var calc_pos_top = faucet_lever_pos['pos_top'] - 50;

				faucet_lever_pos_style = ' transform: translate3d(' + calc_pos_left + '%, ' + calc_pos_top + '%, 0);';

			}

			code += '<div class="m_result__item is-faucet is_faucet_lever ' + cls_faucet_lever + '" style="background-image: url(' + faucet_lever_image + ');' + faucet_lever_pos_style + '" id="result-faucet-lever"></div>';
		}

		code += '<div class="m_result__item is-faucet" style="background-image: url(' + faucet_image + ');' + faucet_pos_style +'" id="result-faucet"></div>';


		code += '<div class="m_result__item is-lavatory" style="background-image: url(' + lavatory_image + ');"></div>';
		code += '<div class="m_result__item is-base" style="background-image: url(' + base_image + ');"></div>';
		code += '</div></div>';

		return code;
	},

	/**
	 * 選択結果用HTMLコード取得（左ナビ、結果画面で仕様）
	 *
	 */
	generateCodeChangeLink: function(link_name, cls) {
		var code = '';

		// cls = cls?cls:'m_absoluteTR';
		cls = 'm_absoluteTR ' + cls;

		code += '<div class="' + cls + '">';
		code += '<a href="#' + link_name + '" class="m_relative m_hover js_hover" data-transition-link="' + link_name + '" data-select-type="chenge" data-select-id="plan">';
		code += '<i class="m_icon__change"></i>';
		code += '<div class="m_absoluteCX m_hover__block m_mgt30 m_dsp-pc">';
		code += '<div class="m_balloon__top"><p class="m_balloon__top--txt m_mgl5">' + ENGINE.Simulator.messages['change_item'] + '</p></div>';
		code += '</div>';
		code += '</a>';
		code += '</div>';

		return code;
	},
	/**
	 * 選択結果用HTMLコード取得（左ナビ、結果画面で使用）
	 *
	 */
	generateCodeSelectedList: function(target_panel_id) {

		var code  = '';
		var total = 0;

		// 選択情報の取得
		// Faucet
		var selected_faucet = ENGINE.Simulator.condition['faucet-product'];
		var selected_faucet_colour = ENGINE.Simulator.condition['faucet-colour'];
		// Lavatory
		var selected_lavatory = ENGINE.Simulator.condition['lavatory-product'];


		// HTMLコードの生成
		var product;
		var product_name, colour_name, product_url, product_price, product_shape;
		var code_change_link, code_product_name, code_icon_list, code_selected_colour, code_colour_list, code_product_link, code_price, code_size;

		var is_select_item = 0;

		// [START] faucetの設定
		code_change_link     = '';
		code_product_name    = '-';
		code_icon_list       = '';
		code_selected_colour = '';
		code_colour_list     = '';
		code_product_link    = '';
		code_price           = '';


		// 選択されている製品の有無により処理分岐
		if (selected_faucet || selected_lavatory) {
			// 必要な場合に記述

		// 何も選択されていない場合
		} else {
			code += '<div class="m_navi__message m_dsp-sp">' + ENGINE.Simulator.messages['your_list_not_found'] + '</div>';
		}

		// faucetが選択されている場合
		if (selected_faucet) {
			product = ENGINE.Simulator.vars.faucet_master[selected_faucet];

			// changeリンク
			// if (target_panel_id == 'result') {
				// code_change_link = ENGINE.Simulator.generateCodeChangeLink('faucet-product');
			// }
			var faucet_change_link = 'faucet-series';
// console.log('generateCodeSelectedList() -  first step :: ' + ENGINE.Simulator.flow_nav['first-step']);
			if (ENGINE.Simulator.flow_nav['first-step'] && ((ENGINE.Simulator.flow_nav['first-step'] == 'faucet-colour') || (ENGINE.Simulator.flow_nav['first-step'] == 'faucet-shape')) ) {
				faucet_change_link = ENGINE.Simulator.flow_nav['first-step'];
			}
// console.log('generateCodeSelectedList() - faucet change link :: ' + faucet_change_link);
// console.log(ENGINE.Simulator.flow_nav);
			code_change_link = ENGINE.Simulator.generateCodeChangeLink(faucet_change_link);

			// 製品名
			code_product_name = product['PRODUCT_ID'] + ' (' + product['SERIES'] + ENGINE.Simulator.messages['category_series'] + ')';

			// アイコンリスト
			code_icon_list = ENGINE.Simulator.generateCode4IconList(product, false);
			code_icon_list = '<ul class="m_list__inline m_list__icon">' + code_icon_list + '</ul>';

			// カラーリスト
 			if (selected_faucet_colour) {
				colour_name = ENGINE.Simulator.messages['colour_' + selected_faucet_colour];

 				// 選択されているカラーの表示
				code_selected_colour  = '<div class="m_navi__colour--selected js_colour__cont--after">';
				code_selected_colour += '<div class="m_navi__colour--balloon-inner js_nav_faucet_colour">';
				code_selected_colour += '<div class="m_navi__colour--balloon-img is_' + selected_faucet_colour + '"></div>';
				code_selected_colour += '<div class="m_navi__colour--balloon-txt"><p>' + colour_name + '</p></div>';
				code_selected_colour += '</div>';
				code_selected_colour += '</div>';

 				// カラー選択欄（結果画面のみ）
				if (target_panel_id == 'result') {
					code_colour_list = ENGINE.Simulator.generateCode4ColourList(product, selected_faucet_colour, 'm_navi__colour', 'action', 'swap-faucet-colour-results', 'faucet-colour');
					code_colour_list = '<ul class="m_list__inline m_navi__colour--list js_colour__check">' + code_colour_list + '</ul>';
				}
 			}

 			// 製品URL
			product_url = product['PRODUCT_URL'];
			if (product_url) {
				code_product_link = '<a href="' + product_url + '" target="_blank"><i class="m_icon__blank--gray m_mgr5"></i>' + ENGINE.Simulator.messages['product_link'] + '</a>';
			}

			// 金額
			product_price = product['PRICE'];
			total += Number(product['PRICE']);
		}

		code += '<div class="m_navi__area">';
		code += '<h2 class="m_ttl__small">' + ENGINE.Simulator.messages['faucet'] + '</h2>';
		// changeリンク
		code += code_change_link;
		// 製品名
		code += '<p class="m_navi__name m_mgt20">' + code_product_name + '</p>';
		// アイコンリスト
		code += code_icon_list;
		// 選択されているカラーの表示
		code += code_selected_colour;
		// カラーリスト
// console.log(code_colour_list);
		code += code_colour_list;

		code += '<div class="m_layout__space-between m_mgt25">';
		// 製品URL
		code += '<p class="m_btn__detail">';
		code += code_product_link;
		code += '</p>';
		// 金額
		if (ENGINE.Simulator.settings['price_flg']) {
			product_price = ENGINE.SimulatorCommon.priceFormat(product_price, ENGINE.Simulator.settings);
			code += '<div class="m_navi__money_box">';
			code += '<p class="m_navi__money is-taR">' + product_price + '</p>';
			code += '<p class="m_navi__money--txt is-taR">' + ENGINE.Simulator.messages['tax_include'] + '</p>';
			code += '</div>';
		}

		code += '</div>';

		code += '</div><!--/ .m_navi__area -->';
		// [END] faucetの設定



		// [START] lavatoryの設定
		code_change_link     = '';
		code_product_name    = '-';
		code_icon_list       = '';
		code_selected_colour = '';
		code_colour_list     = '';
		code_product_link    = '';
		code_price           = '';
		product_price        = 0;
		code_size            = '';

		// lavatoryが選択されている場合
		if (selected_lavatory) {
			product = ENGINE.Simulator.vars.lavatory_master[selected_lavatory];

			// changeリンク
			// if (target_panel_id == 'result') {
				// code_change_link = ENGINE.Simulator.generateCodeChangeLink('lavatory-product');
			// }
			code_change_link = ENGINE.Simulator.generateCodeChangeLink('lavatory-shape');

			// 製品名
			product_shape = product['SHAPE'];
			code_product_name = product['PRODUCT_ID'] + ' (' + ENGINE.Simulator.messages['lavatory_shape_' + product_shape] + ')';

			// サイズの表示
			code_size  = '<div class="m_navi__size">';
			code_size += 'W' + product["SIZE_W"] + ' × ';
			code_size += 'H' + product["SIZE_H"] + ' × ';
			code_size += 'D' + product["SIZE_D"] + '';
			code_size += '</div>';


			// アイコンリスト
			code_icon_list = ENGINE.Simulator.generateCode4IconList(product, false);
			code_icon_list = '<ul class="m_list__inline m_list__icon">' + code_icon_list + '</ul>';

			// カラーリスト
 			if (selected_faucet_colour) {
				colour_name = ENGINE.Simulator.messages['colour_W'];

 				// 選択されているカラーの表示
				code_selected_colour  = '<div class="m_navi__colour--selected">';
				code_selected_colour += '<div class="m_navi__colour--balloon-inner">';
				code_selected_colour += '<div class="m_navi__colour--balloon-img is_WHITE"></div>';
				code_selected_colour += '<div class="m_navi__colour--balloon-txt"><p>' + colour_name + '</p></div>';
				code_selected_colour += '</div>';
				code_selected_colour += '</div>';


 				// カラー選択欄（結果画面のみ）
				if (target_panel_id == 'result') {
					code_colour_list = ENGINE.Simulator.generateCode4ColourList(product, selected_faucet_colour, 'm_navi__colour');
					code_colour_list = '<ul class="m_list__inline m_navi__colour--list js_colour__check">' + code_colour_list + '</ul>';
				}
 			}

 			// 製品URL
			product_url = product['PRODUCT_URL'];
			if (product_url) {
				code_product_link = '<a href="' + product_url + '" target="_blank"><i class="m_icon__blank--gray m_mgr5"></i>' + ENGINE.Simulator.messages['product_link'] + '</a>';
			}

			// 金額
			product_price = product['PRICE'];
			total += Number(product['PRICE']);
		}

		code += '<div class="m_navi__area m_border-top__none">';
		code += '<h2 class="m_ttl__small">' + ENGINE.Simulator.messages['lavatory'] + '</h2>';
		// changeリンク
		code += code_change_link;
		// 製品名
		code += '<p class="m_navi__name m_mgt20">' + code_product_name + '</p>';
		// サイズ（Lavatoryのみ）
		code += code_size;
		// アイコンリスト
		code += code_icon_list;
		// 選択されているカラーの表示
		code += code_selected_colour;
		// カラーリスト
		code += code_colour_list;

		code += '<div class="m_layout__space-between m_mgt25">';
		// 製品URL
		code += '<p class="m_btn__detail">';
		code += code_product_link;
		code += '</p>';
		// 金額
		if (ENGINE.Simulator.settings['price_flg']) {
			product_price = ENGINE.SimulatorCommon.priceFormat(product_price, ENGINE.Simulator.settings);
			code += '<div class="m_navi__money_box">';
			code += '<p class="m_navi__money is-taR">' + product_price + '</p>';
			code += '<p class="m_navi__money--txt is-taR">' + ENGINE.Simulator.messages['tax_include'] + '</p>';
			code += '</div>';
		}

		code += '</div>';

		code += '</div><!--/ .m_navi__area -->';
		// [END] lavatoryの設定


    // 合計金額
		if (ENGINE.Simulator.settings['price_flg']) {
			code += '<div class="m_navi__total"><div class="m_navi__wrap">';
			code += '<h2 class="m_ttl__small is-color-base">' + ENGINE.Simulator.messages['total_amount'] + '</h2>';
			code += '<p class="m_navi__money is-fwB">' + ENGINE.SimulatorCommon.priceFormat(total, ENGINE.Simulator.settings) + '</p>';
			code += '</div>';
			code += '<p class="m_navi__money--txt is-taR">' + ENGINE.Simulator.messages['tax_include'] + '</p>';
			code += '</div>';
		}

		if (selected_lavatory) {
			code += '<p class="m_navi__note m_mgt10">' + ENGINE.Simulator.messages['lavatory_annotation'] + '</p>';
		}

		return code;

	},

	/**
	 * 結果画面用
	 *
	 */
	generateCodeResult: function(stage_id, faucet_id, faucet_colour, lavatory_id) {

		var code = '';

    // 結果画像
		code += '<div class="m_result is-faucet-lavatory">';
		code += ENGINE.Simulator.generateCodeResultImage('m_result', faucet_id, faucet_colour, lavatory_id);
		code += '</div>';

		code += '<p class="m_result__note m_inner_padding_sp">' + ENGINE.Simulator.messages['result_annotation'] + '</p>';

		code += '<ul class="m_result__btn m_inner_padding_sp">';
		code += '<li class="m_btn__black"><a href="#" data-action-link="add-favorite"><i class="m_icon__star--white m_mgr5"></i>' + ENGINE.Simulator.messages['add_favarite_link'] + '</a></li>';

		// PDFダウンロード
		if (ENGINE.Simulator.settings['pdf_flg']) {
			code += '<li class="m_btn__black"><a href="#" data-action-link="download-pdf"><i class="m_icon__download--white m_mgr5"></i>' + ENGINE.Simulator.messages['download_link'] + '</a></li>';
		}

		// Share
		if (ENGINE.Simulator.settings['sns_flg']) {
			code += '<li class="m_btn__black"><a href="#" data-action-link="open-share"><i class="m_icon__share--white m_mgr5"></i>' + ENGINE.Simulator.messages['share_link'] + '</a></li>';
		}

		code += '</ul>';
		code += '</div>';

		return code;
	},

	/**
	 * お気に入り画面用HTMLコード取得
	 *
	 */
	generateCodeSaved: function(favorite) {

		var code  = '';
		var total = 0;

		// 選択情報の取得
		var id = favorite['id'];

		var datetime = favorite['dt'];
		var selected_faucet = favorite['fid'];
		var selected_lavatory = favorite['lid'];
		var selected_faucet_colour = favorite['fc'];


		// HTMLコードの生成
		var product;
		var product_name, colour_name, product_url, product_price, product_shape, product_image;
		var code_product_image, code_change_link, code_product_name, code_icon_list, code_selected_colour, code_colour_list, code_product_link, code_price;

		var faucet_product_image, lavatory_product_image, faucet, lavatory, lavaroty_product_image_name;
		var code_result_image, code_head, code_all;
		var $result_image;

		// [START] faucetの設定
		code_change_link     = '';
		code_product_name    = '-';
		code_icon_list       = '';
		code_selected_colour = '';
		code_colour_list     = '';
		code_product_link    = '';
		code_price           = '';


		// faucetが選択されている場合
		if (selected_faucet) {
			product = ENGINE.Simulator.vars.faucet_master[selected_faucet];
			faucet = product;

			// 製品画像
			// 後述処理のために別変数に格納
			code_product_image = ENGINE.Simulator.generateCodeProductImage4List('faucet', faucet, selected_faucet_colour);

			// changeリンク
			// code_change_link = ENGINE.Simulator.generateCodeChangeLink('faucet-product', 'm_saved__change');
			var faucet_change_link = 'faucet-series';
// console.log('generateCodeSelectedList() -  first step :: ' + ENGINE.Simulator.flow_nav['first-step']);
			if (ENGINE.Simulator.flow_nav['first-step'] && ((ENGINE.Simulator.flow_nav['first-step'] == 'faucet-colour') || (ENGINE.Simulator.flow_nav['first-step'] == 'faucet-shape')) ) {
				faucet_change_link = ENGINE.Simulator.flow_nav['first-step'];
			}
			code_change_link = ENGINE.Simulator.generateCodeChangeLink(faucet_change_link, 'm_saved__change');

			// 製品名
			code_product_name = product['PRODUCT_ID'] + ' (' + product['SERIES'] + ENGINE.Simulator.messages['category_series'] + ')';

			// アイコンリスト
			code_icon_list = ENGINE.Simulator.generateCode4IconList(product, false);
			code_icon_list = '<ul class="m_list__inline m_list__icon is-taL">' + code_icon_list + '</ul>';

			// カラーリスト
 			if (selected_faucet_colour) {
				colour_name = ENGINE.Simulator.messages['colour_' + selected_faucet_colour];

 				// 選択されているカラーの表示
				code_selected_colour  = '<div class="m_navi__colour--selected">';
				code_selected_colour += '<div class="m_navi__colour--balloon-inner m_mgb0">';
				code_selected_colour += '<div class="m_navi__colour--balloon-img is_' + selected_faucet_colour + '"></div>';
				code_selected_colour += '<div class="m_navi__colour--balloon-txt"><p>' + colour_name + '</p></div>';
				code_selected_colour += '</div>';
				code_selected_colour += '</div>';
 			}

 			// 製品URL
			product_url = product['PRODUCT_URL'];
			if (product_url) {
				code_product_link  = '<div class="m_saved__detail--btn">';
				code_product_link += '<p class="m_btn__detail">';
				code_product_link += '<a href="' + product_url + '" target="_blank"><i class="m_icon__blank--gray m_mgr5"></i>' + ENGINE.Simulator.messages['product_link'] + '</a>';
				code_product_link += '</p>';
				code_product_link += '</div>';
			}

			// 金額
			product_price = product['PRICE'];
			total += Number(product['PRICE']);
		}

		code += '<div class="m_saved__list"><div class="m_saved__list--inner">';
		// 製品画像
		code += '<div class="m_saved__list--img">' + code_product_image + '</div>';

    code += '<div class="m_saved__list--info">';
    // 製品カテゴリ名
		code += '<h2 class="m_ttl__small m_mgb15 is-taL">' + ENGINE.Simulator.messages['faucet'] + '</h2>';
		// 製品名
		code += '<p class="m_ttl_middle m_mgb10">' + code_product_name + '</p>';
		// アイコンリスト
		code += code_icon_list;
		// 選択されているカラーの表示
		code += code_selected_colour;
		code += '</div><!-- /.m_saved__list--info -->';

		code += '<div class="m_saved__list--price">';
		// changeリンク
		code += code_change_link;

		// 金額
		if (ENGINE.Simulator.settings['price_flg']) {
			product_price = ENGINE.SimulatorCommon.priceFormat(product_price, ENGINE.Simulator.settings);
			code += '<p class="m_navi__money is-taR">' + product_price + '</p>';
			code += '<p class="m_navi__money--txt is-taR">' + ENGINE.Simulator.messages['tax_include'] + '</p>';
		}

		// 製品URL
		code += code_product_link;

		code += '</div><!--/ .m_saved__list--price -->';
		code += '</div><!--/ .m_saved__list--inner -->';
		code += '</div><!--/ .m_saved__list -->';
		// [END] faucetの設定


		// [START] lavatoryの設定
		code_change_link     = '';
		code_product_name    = '-';
		code_icon_list       = '';
		code_selected_colour = '';
		code_colour_list     = '';
		code_product_link    = '';
		code_price           = '';
		product_price        = 0;

		// lavatoryが選択されている場合
		if (selected_lavatory) {
			product = ENGINE.Simulator.vars.lavatory_master[selected_lavatory];
			lavatory = product;

			// 製品画像
			// 後述処理のために別変数に格納
			code_product_image = ENGINE.Simulator.generateCodeProductImage4List('lavatory', lavatory);

			// changeリンク
			code_change_link = ENGINE.Simulator.generateCodeChangeLink('lavatory-shape', 'm_saved__change');

			// 製品名
			product_shape = product['SHAPE'];
			code_product_name = product['PRODUCT_ID'] + ' (' + ENGINE.Simulator.messages['lavatory_shape_' + product_shape] + ')';

			// アイコンリスト
			code_icon_list = ENGINE.Simulator.generateCode4IconList(product, false);
			code_icon_list = '<ul class="m_list__inline m_list__icon is-taL">' + code_icon_list + '</ul>';

			// カラーリスト
 			if (selected_faucet_colour) {
				colour_name = ENGINE.Simulator.messages['colour_W'];

 				// 選択されているカラーの表示
				code_selected_colour  = '<div class="m_navi__colour--selected">';
				code_selected_colour += '<div class="m_navi__colour--balloon-inner m_mgb0">';
				code_selected_colour += '<div class="m_navi__colour--balloon-img is_WHITE"></div>';
				code_selected_colour += '<div class="m_navi__colour--balloon-txt"><p>' + colour_name + '</p></div>';
				code_selected_colour += '</div>';
				code_selected_colour += '</div>';
 			}

 			// 製品URL
			product_url = product['PRODUCT_URL'];
			if (product_url) {
				code_product_link  = '<div class="m_saved__detail--btn">';
				code_product_link += '<p class="m_btn__detail">';
				code_product_link += '<a href="' + product_url + '" target="_blank"><i class="m_icon__blank--gray m_mgr5"></i>' + ENGINE.Simulator.messages['product_link'] + '</a>';
				code_product_link += '</p>';
				code_product_link += '</div>';
			}

			// 金額
			product_price = product['PRICE'];
			total += Number(product['PRICE']);
		}

		code += '<div class="m_saved__list m_mgt10"><div class="m_saved__list--inner">';
		// 製品画像
		code += '<div class="m_saved__list--img">' + code_product_image + '</div>';

    code += '<div class="m_saved__list--info">';
    // 製品カテゴリ名
		code += '<h2 class="m_ttl__small m_mgb15 is-taL">' + ENGINE.Simulator.messages['lavatory'] + '</h2>';
		// 製品名
		code += '<p class="m_ttl_middle m_mgb10">' + code_product_name + '</p>';
		// アイコンリスト
		code += code_icon_list;
		// 選択されているカラーの表示
		code += code_selected_colour;
		code += '</div><!-- /.m_saved__list--info -->';

		// changeリンク
		code += '<div class="m_saved__list--price">';

		code += code_change_link;

		// 金額
		if (ENGINE.Simulator.settings['price_flg']) {
			product_price = ENGINE.SimulatorCommon.priceFormat(product_price, ENGINE.Simulator.settings);
			code += '<p class="m_navi__money is-taR">' + product_price + '</p>';
			code += '<p class="m_navi__money--txt is-taR">' + ENGINE.Simulator.messages['tax_include'] + '</p>';
		}

		// 製品URL
		code += code_product_link;

		code += '</div><!--/ .m_saved__list--price -->';
		code += '</div><!--/ .m_saved__list--inner -->';
		code += '</div><!--/ .m_saved__list -->';
		// [END] lavatoryの設定


    // 合計金額
		if (ENGINE.Simulator.settings['price_flg']) {
			code += '<div class="m_saved__total m_mgt40"><div class="m_navi__wrap">';
			code += '<h2 class="m_ttl__small is-color-base">' + ENGINE.Simulator.messages['total_amount'] + '</h2>';
			code += '<p class="m_navi__money is-fwB">' + ENGINE.SimulatorCommon.priceFormat(total, ENGINE.Simulator.settings) + '</p>';
			code += '</div>';
			code += '<p class="m_navi__money--txt is-taR">' + ENGINE.Simulator.messages['tax_include'] + '</p>';
			code += '</div>';
		}

    code += '<p class="m_navi__note m_mgt10 is-taR">' + ENGINE.Simulator.messages['lavatory_annotation'] + '</p>';


    // 結果画像
    code_result_image  = '<div class="m_saved__img m_result is-faucet-lavatory">';
		code_result_image += ENGINE.Simulator.generateCodeResultImage('m_result', selected_faucet, selected_faucet_colour, selected_lavatory);
		code_result_image += '<p class="m_saved__note">' + ENGINE.Simulator.messages['result_annotation'] + '</p>';
		code_result_image += '</div>';

    // HEADER
		code_head  = '<div class="m_saved__head m_mgb30">';
		// 製品名（すべて）
		code_head += '<p class="m_saved__head--name m_ttl_middle">' + selected_faucet + ' / ' + selected_lavatory + '</p>';
		// 保存日時
		code_head += '<time class="m_saved__head--date" id="saved_datetime">' + datetime + '</time>';
		code_head += '</div>';

		// 全体
		code_all = code_result_image;
		code_all += '<div class="m_inner_padding__m m_mgt55">';
		code_all += code_head;
		code_all += code;
		code_all += '</div>';

		// ページ下部
		code_all += '<div class="m_inner_padding__m m_rsp_mgt55">';
		code_all += '<ul class="m_saved__btn">';
		code_all += '<li class="m_btn__black"><a href="#" data-transition-link="compare"><i class="m_icon__compare--white m_mgr5"></i>' + ENGINE.Simulator.messages['compare_link'] + '</a></li>';

		// PDFダウンロード
		if (ENGINE.Simulator.settings['pdf_flg']) {
			code_all += '<li class="m_btn__black"><a href="#" data-action-link="download-pdf-saved" data-select-type="id" data-select-id="' + id + '" class=""><i class="m_icon__download--white m_mgr5"></i>' + ENGINE.Simulator.messages['download_link'] + '</a></li>';
		}

		// Share
		if (ENGINE.Simulator.settings['sns_flg']) {
			code_all += '<li class="m_btn__black"><a href="#" data-action-link="open-share-saved" data-select-type="id" data-select-id="' + id + '" class=""><i class="m_icon__share--white m_mgr5"></i>' + ENGINE.Simulator.messages['share_link'] + '</a></li>';
		}

		code_all += '</ul>';
		code_all += '</div>';

		return code_all;

	},

	/**
	 * 
	 *
	 */
	generateCodeShareModal: function(selected_faucet, selected_faucet_colour, selected_lavatory) {
		var code = '';

		var code_product_name,code_icon_list,code_colour_list,product_url,code_product_url,product_price,code_size;

		var code_product_image, product_image;
		var product_name, colour_name;
		var faucet, lavatory;

		var code_faucet = '';
		var code_lavatory = '';

		// [START] faucetの設定
		// faucetが選択されている場合
		if (selected_faucet) {
			// 製品情報の取得
			faucet = ENGINE.Simulator.vars.faucet_master[selected_faucet];

			// 製品名
			product_name = faucet['PRODUCT_ID'] + ' (' + faucet['SERIES'] + ENGINE.Simulator.messages['category_series'] + ')';

			// アイコンリスト
			code_icon_list = ENGINE.Simulator.generateCode4IconList(faucet, false);

			// カラー
			colour_name = ENGINE.Simulator.messages['colour_' + selected_faucet_colour];

			// HTMLタグの整形
			code_faucet += '<h2 class="m_ttl__small">' + ENGINE.Simulator.messages['faucet'] + '</h2>';

			code_faucet += '<div class="m_modal__txtArea--head m_rsp_mgt15">';
			code_faucet += '<div class="m_ttl__name">' + product_name + '</div>';
			code_faucet += '<ul class="m_list__inline m_list__icon">' + code_icon_list + '</ul>';
			code_faucet += '</div><!--/ .m_modal__txtArea--head -->';

			code_faucet += '<div class="m_navi__colour--selected">';
			code_faucet += '<div class="m_navi__colour--balloon-inner">';
			code_faucet += '<div class="m_navi__colour--balloon-img is_' + selected_faucet_colour + '"></div>';
			code_faucet += '<div class="m_navi__colour--balloon-txt"><p>' + colour_name + '</p></div>';

			code_faucet += '</div>';
			code_faucet += '</div><!--/ .m_navi__colour--selected -->';

		}
		// [END] faucetの設定

		// [START] lavatoryの設定
		// lavatoryが選択されている場合
		if (selected_lavatory) {
			lavatory = ENGINE.Simulator.vars.lavatory_master[selected_lavatory];
			var lavatory_shape = lavatory['SHAPE'];

			// 製品名
			code_product_name = lavatory['PRODUCT_ID'] + ' (' + ENGINE.Simulator.messages['lavatory_shape_' + lavatory_shape] + ')';

			// アイコンリスト
			code_icon_list = ENGINE.Simulator.generateCode4IconList(lavatory, false);

			code_lavatory += '<h2 class="m_ttl__small">' + ENGINE.Simulator.messages['lavatory'] + '</h2>';
			code_lavatory += '<div class="m_modal__txtArea--head m_rsp_mgt15">';
			code_lavatory += '<div class="m_ttl__name">' + code_product_name + '</div>';
			code_lavatory += '<ul class="m_list__inline m_list__icon">' + code_icon_list + '</ul>';
			code_lavatory += '</div><!--/ .m_modal__txtArea--head -->';
			code_lavatory += '<div class="m_navi__colour--selected">';
			code_lavatory += '<div class="m_navi__colour--balloon-inner">';
			code_lavatory += '<div class="m_navi__colour--balloon-img is_WHITE"></div>';
			code_lavatory += '<div class="m_navi__colour--balloon-txt">';
			code_lavatory += '<p>' + ENGINE.Simulator.messages['colour_W'] + '</p>';
			code_lavatory += '</div><!--/ .m_navi__colour--balloon-txt -->';
			code_lavatory += '</div><!--/ .m_navi__colour--balloon-inner -->';
			code_lavatory += '</div><!--/ .m_navi__colour--selected -->';

		}
		// [END] lavatoryの設定

		// 製品画像
		// code_product_image = ENGINE.Simulator.generateCodeProductImage4Result(faucet_product_image, faucet, lavatory_product_image, lavatory, selected_faucet_colour);
		code_product_image = ENGINE.Simulator.generateCodeProductImage4Result(faucet, selected_faucet_colour, lavatory);

		code += '<div class="m_modal__imgArea">';
		code += '<div class="m_modal__imgArea--img">' + code_product_image + '</div>';
		code += '<p class="m_modal__imgArea--txt">©TOTO LTD.</p>';

		code += '<p class="m_modal__note">' + ENGINE.Simulator.messages['result_annotation'] + '</p>';

		code += '</div><!--/ .m_modal__imgArea -->';

		code += '<div class="m_modal__txtArea">';

		code += '<div class="m_pdt20">';
		code += code_faucet;
		code += '</div><!--/ .m_pdt20 -->';

		code += '<div class="m_border-top m_mgt25 m_pdt20">';
		code += code_lavatory;
		code += '</div><!--/ .m_border-top -->';

		code += '<p class="m_modal__note">' + ENGINE.Simulator.messages['lavatory_annotation'] + '</p>';
		code += '</div><!--/ .m_modal__txtArea -->';


		return code;
	},


	/**
	 * 技術アイコン、デザインアイコン用のHTMLコード取得
	 *
	 */
	generateCode4IconList: function(product, is_wrap) {

		var code_list = '';
		var code_tech_list = '';
		var code_design_list = '';
		var tech_list = ENGINE.Simulator.settings['technologies'];
		var tech_flg, tech;

		// 技術アイコン、デザインアイコン
		for(var idx in tech_list) {
			tech_flg = product['TECH_' + idx];
			tech = tech_list[idx];
			if (tech_flg) {
				code_tech_list += '<li><img src="' + ENGINE.Simulator.settings['icon_image'] + 'technologies/' + tech['id'] + '@2x.png" alt="' + tech['name'] + '"></li>';
			}
		}
		if ( product['AWARD_01'] && (product['AWARD_01'] != '') ) {
			code_design_list += '<li><img src="' + ENGINE.Simulator.settings['icon_image'] + 'award/' + product['AWARD_01'] + '@2x.png" alt="' + product['AWARD_01'] + '"></li>';
		}
		if ( product['AWARD_02'] && (product['AWARD_02'] != '') ) {
			code_design_list += '<li><img src="' + ENGINE.Simulator.settings['icon_image'] + 'award/' + product['AWARD_02'] + '@2x.png" alt="' + product['AWARD_02'] + '"></li>';
		}

		if (code_tech_list || code_design_list) {
			if (is_wrap) {
				code_list += '<ul class="m_list__inline m_list__icon is-taR m_mgr10">';
			}
			code_list += code_tech_list + code_design_list;
			if (is_wrap) {
				code_list += '</ul>';
			}
		}

		return code_list;
	},
	/**
	 *
	 *
	 */
	generateCode4ColourList: function(product, default_colour_id, cls, link_type, link_value, param_id) {
// console.log('generateCode4ColourList() - start.');
		var faucet_colour = ENGINE.Simulator.settings['faucet_colour'];

		var colour, field_id, colour_name;
		var code_list = '';
		var code_list_child = '';

		var data_attributes = '';

		var cls_item = '';

// console.log(product);
		for(var cat_id in faucet_colour) {

			code_list_child = '';
			for (var colour_id in faucet_colour[cat_id]) {

				colour      = faucet_colour[cat_id][colour_id];
				field_id   = 'COLOUR_' + colour_id;
				colour_name = ENGINE.Simulator.messages['colour_' + colour_id];

				if ( product[field_id] && (product[field_id] == 1) ) {
					cls_item = (default_colour_id == colour_id)?'is_active':'';
					code_list_child += '<li class="js_hover ' + cls_item + '">';

// generateCode4ColourList
					data_attributes = '';
					if (link_type && link_value && param_id) {
						if (link_type == 'action') {
							data_attributes = 'data-action-link="' + link_value + '" data-select-type="' + param_id + '" data-select-id="' + colour_id + '"';
						} else {
							data_attributes = 'data-transition-link="' + link_value + '" data-search-type="' + param_id + '" data-search-id="' + colour_id + '"';
						}
					}

					code_list_child += '<button class="' + cls + '--btn is_' + colour_id + '" ' + data_attributes + '></button>';

					code_list_child += '<div class="' + cls + '--balloon"><div class="' + cls + '--balloon-inner">';

					code_list_child += '<div class="' + cls + '--balloon-img is_' + colour_id + '"></div>';

					code_list_child += '<div class="' + cls + '--balloon-txt"><p>';
					code_list_child += colour_name;
					code_list_child += '</p></div>';

					code_list_child += '</div>';

					code_list_child += '</li>';
				}
			}

			if (code_list_child) {
				// code_list += '<li class="m_colour-select__list--ttl">' + ENGINE.Simulator.messages['category_colour_' + cat_id] + '</li>'
				code_list += '<li class="' + cls + '--ttl">' + ENGINE.Simulator.messages['category_colour_' + cat_id] + '</li>'
				code_list += code_list_child;
			}

		}

// console.log('generateCode4ColourList() - end.');

		return code_list;
	},
	/**
	 * お気に一覧（左ナビ）用のHTMLコード生成
	 *
	 */
	generateCodeFavoriteItem4Navi(type, favoriteAt) {
		var code = '';

		var id = favoriteAt['id'];
		var datetime = favoriteAt['dt'];
		var faucet_id = favoriteAt['fid'];
		var lavatory_id = favoriteAt['lid'];
		var faucet_colour = favoriteAt['fc'];

		var faucet    = ENGINE.Simulator.searchProductAt('faucet-product', faucet_id);
		var lavatory = ENGINE.Simulator.searchProductAt('lavatory-product', lavatory_id);

		// 結果画像の取得
		var code_product_image = ENGINE.Simulator.generateCodeProductImage4Result(faucet, faucet_colour, lavatory);

		var code_icon_list = '';

		if (type == 'compare') {

			code += '<li class="m_model-col2__item" data-action-link="swap-favorite-compare" data-select-type="id" data-select-id="' + id + '">';
			code += '<input type="checkbox" name="checkbox" class="m_radio__input" id="radio_' + id + '" data-select-type="saved" data-select-id="' + id + '" value="" checked="checked">';
			code += '<label for="radio_' + id + '" class="m_model-col2__btn">';
			code += '<div class="m_radio__icon">';
			code += '<i class="m_radio__icon--inner"></i>';
			code += '</div>';

			code += '<div class="m_model-col2__img">' + code_product_image + '</div>';
			code += '<div class="m_model-col2__box">';
			code += '<p class="m_model-col2__name">' + faucet_id + ' / ' + lavatory_id + '</p>';

			code_icon_list += ENGINE.Simulator.generateCode4IconList(faucet, false);
			code_icon_list += ENGINE.Simulator.generateCode4IconList(lavatory, false);

			if (code_icon_list) {
				code += '<ul class="m_list__inline m_list__icon m_mgt10">';
				code += code_icon_list;
				code += '</ul>';
			}

			code += '<time class="m_model-col2__date">' + datetime + '</time>';
			code += '</div></label></li>';

		} else if (type == 'saved') {

			// code += '<li class="m_model-col2__item" data-action-link="swap-favorite-save" data-select-type="id" data-select-id="' + id + '">';
			code += '<li class="m_model-col2__item" data-transition-link="saved" data-select-type="saved" data-select-id="' + id + '">';
			code += '<div class="m_model-col2__btn">';
			code += '<div class="m_model-col2__img">' + code_product_image + '</div>';
			code += '<div class="m_model-col2__box">';
			code += '<p class="m_model-col2__name">' + faucet_id + ' / ' + lavatory_id + '</p>';

			code_icon_list += ENGINE.Simulator.generateCode4IconList(faucet, false);
			code_icon_list += ENGINE.Simulator.generateCode4IconList(lavatory, false);

			if (code_icon_list) {
				code += '<ul class="m_list__inline m_list__icon m_mgt10">';
				code += code_icon_list;
				code += '</ul>';
			}

			code += '<time class="m_model-col2__date">' + datetime + '</time>';
			code += '</div>';
			code += '</div>';
			code += '</li>';

		} else {
			code += '<li class="m_favorite__item">';
			code += '<a href="#saved" data-transition-link="saved" data-select-type="saved" data-select-id="' + id + '">';
			code += '<div class="m_favorite__img">' + code_product_image + '</div>';
			code += '<div class="m_favorite__box">';
			code += '<p class="m_favorite__name">' + faucet_id + ' / ' + lavatory_id + '</p>';
			code += '<time class="m_favorite__date">' + datetime + '</time>';
			code += '</div></a></li>';
		}

		return code;
	},
	//////////////////////////////////////////////////////////////////
	// [END] HTMLコード生成処理（シミュレータ固有）
	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// [START] 製品検索系の処理（シミュレータ固有）
	//////////////////////////////////////////////////////////////////
	/**
	 * 製品情報（Faucet）の検索
	 *
	 */
	searchProducts4Faucet(search_type, search_id) {

// console.log('searchProducts4Faucet() - start.');

		var result = [];
		var list = ENGINE.Simulator.vars.faucet_list;

		var product;
		var is_search_found, is_relation_found, faucet_id;
		var selected_lavatory = ENGINE.Simulator.condition['lavatory-product'];

		var selected_faucet_series = ENGINE.Simulator.condition['faucet-series'];
		var selected_faucet_shape  = ENGINE.Simulator.condition['faucet-shape'];
		var selected_faucet_colour = ENGINE.Simulator.condition['faucet-colour'];


// console.log('searchProducts4Faucet() : selected lavatory[' + selected_lavatory + ']');
// console.log('searchProducts4Faucet() : selected faucet series[' + selected_faucet_series + ']');
// console.log('searchProducts4Faucet() : selected faucet shape[' + selected_faucet_shape + ']');
// console.log('searchProducts4Faucet() : selected faucet colour[' + selected_faucet_colour + ']');

		for(var i=0,max=list.length; i<max; i++) {
			is_search_found = false;
			is_relation_found = false;
			product   = list[i];
			faucet_id = product['PRODUCT_ID'];

			// 検索条件に合致しているかのチェック
			is_search_found = true;
			// seriesが選択されている場合、製品のseriesが異なる場合、検索対象外
			if ( selected_faucet_series && (product['SERIES'] != selected_faucet_series) ) {
// console.log('searchProducts4Faucet() : not equal series product[' + product['SERIES'] + '] selected[' + selected_faucet_series + ']');
				is_search_found = false;
			}
			// shapeが選択されている場合、製品のshapeが異なる場合、検索対象外
			if ( selected_faucet_shape && (product['SHAPE'] != selected_faucet_shape) ) {
// console.log('searchProducts4Faucet() : not equal shape product[' + product['SHAPE'] + '] selected[' + selected_faucet_shape + ']');
				is_search_found = false;
			}
			// colourが選択されている場合、製品のcolourが異なる場合、検索対象外
			if ( selected_faucet_colour && (product['COLOUR_' + selected_faucet_colour] != '1') ) {
// console.log('searchProducts4Faucet() : not equal colour product normal[' + product['COLOUR_' + selected_faucet_colour] + '] selected[' + selected_faucet_colour + ']');
				is_search_found = false;
			}

// console.log('searchProducts4Faucet() : !! search relation !!');
			// 組み合わせ条件に合致しているかのチェック
			if (selected_lavatory) {
// console.log('searchProducts4Faucet() : judge relation : lavatory[' + selected_lavatory + '] faucet[' + faucet_id + ']');
				if (is_search_found) {
					if (ENGINE.Simulator.vars.lavatory_relation_list && ENGINE.Simulator.vars.lavatory_relation_list[selected_lavatory] && ENGINE.Simulator.vars.lavatory_relation_list[selected_lavatory][faucet_id]) {
// console.log('searchProducts4Faucet() : Bingo!!');
						is_relation_found = true;
					} else {
// console.log('searchProducts4Faucet() : Boooo!!');
					}
				}
			} else {
// console.log('searchProducts4Faucet() : lavatory not selected.');
				is_relation_found = true;
			}

			if (is_search_found && is_relation_found) {
				result.push(product);
			}
		}
// console.log('searchProducts4Faucet() : result count : ' + result.length);

// console.log('searchProducts4Faucet() - end.');

		return result;
	},
	/**
	 * 製品情報（Faucet）の検索
	 *
	 */
	searchProducts4Lavatory(search_type, search_id) {

// console.log('searchProducts4Lavatory() - start.');
// console.log('searchProducts4Lavatory() : search type : ' + search_type);
// console.log('searchProducts4Lavatory() : search id   : ' + search_id);

		var result = [];
		var list = ENGINE.Simulator.vars.lavatory_list;

		var product;
		var is_search_found, is_relation_found, lavatory_id;
		var selected_faucet = ENGINE.Simulator.condition['faucet-product'];

// console.log('searchProducts4Lavatory() : show condition');
// console.log(ENGINE.Simulator.condition);
// console.log('searchProducts4Lavatory() : selected faucet[' + selected_faucet + ']');
// console.log('searchProducts4Lavatory() : show relation list');
// console.log(ENGINE.Simulator.vars.faucet_relation_list[selected_faucet]);

		for(var i=0,max=list.length; i<max; i++) {
			is_search_found   = false;
			is_relation_found = false;
			product = list[i];
			lavatory_id = product['PRODUCT_ID'];

			// 検索条件に合致しているかのチェック
			if (search_type == 'lavatory-shape') {
// console.log('searchProducts4Lavatory() : shape[' + product['SHAPE'] + '] search_id[' + search_id + '}');
				if (product['SHAPE'] == search_id) {
					is_search_found = true;
				}
			}

			// 組み合わせ条件に合致しているかのチェック
			if (selected_faucet) {
// console.log('searchProducts4Lavatory() : !! search relation !!');
// console.log('searchProducts4Lavatory() : lavatory[' + selected_faucet + '] faucet[' + lavatory_id + ']');
				if (is_search_found) {
					if (ENGINE.Simulator.vars.faucet_relation_list && ENGINE.Simulator.vars.faucet_relation_list[selected_faucet] && ENGINE.Simulator.vars.faucet_relation_list[selected_faucet][lavatory_id]) {
// console.log('searchProducts4Lavatory() : Bingo!!');
						is_relation_found = true;
					}
				}
			} else {
				is_relation_found = true;
			}

			if (is_search_found && is_relation_found) {
				result.push(product);
			}
		}
// console.log('searchProducts4Lavatory() : result count : ' + result.length);

// console.log('searchProducts4Lavatory() - end.');

		return result;
	},

	/**
	 * 製品情報の取得
	 *
	 *
	 */
	searchProductAt: function(type, id) {
		// 製品データの取得（配列ではなく、オブジェクトから取得）
		var master = (type=='faucet-product')?ENGINE.Simulator.vars.faucet_master:ENGINE.Simulator.vars.lavatory_master;

		var result = false;
		if (master && master[id]) {
			result = master[id];
		}

		return result;
	},

	/**
	 * FaucetがZLの場合のレバー位置調整
	 * ※LavatoryのShape / 幅（w）/奥行き（）と比較から設置位置を取得
	 */
	getFaucetLeverPosition(faucet_id, faucet, lavatory_id, lavatory) {
		var pos = 0;

		var faucet   = faucet?faucet:ENGINE.Simulator.searchProductAt('faucet-product', faucet_id);
		var lavatory = lavatory?lavatory:ENGINE.Simulator.searchProductAt('lavatory-product', lavatory_id);

		var faucet_shape    = faucet['SHAPE'];
		var faucet_series   = faucet['SERIES'];
		var faucet_category = faucet['CATEGORY_1'];

		var lavatory_shape = lavatory['SHAPE'];
		var lavatory_inset = (lavatory['CATEGORY_2']=='inset')?'inset':'outset';
		var lavatory_w     = lavatory['SIZE_W'];
		var lavatory_h     = lavatory['SIZE_H'];

// console.log('getFaucetLeverPosition() - START.');
// console.log(lavatory);
// console.log('faucet   : ' + faucet_shape + ' : ' + faucet_series + ' : ' + faucet_category);
// console.log('lavatory : ' + lavatory_shape + ' : ' + lavatory_id + ' : ' + lavatory_w + ' : ' + lavatory_h);
		if (lavatory_shape == 'under') {

			var lavatory_add = (lavatory['SIZE_H'] - lavatory['SIZE_B-H']) / 2;
			lavatory_w = lavatory['SIZE_B-W']?lavatory['SIZE_B-W']:lavatory_w;
			lavatory_h = lavatory['SIZE_B-H']?lavatory['SIZE_B-H']:lavatory_h;
// console.log(' add ' + lavatory_add + ' : ' + lavatory_h);
			if (lavatory_add && (lavatory_add > 0)) {
				lavatory_h = parseInt(lavatory_h) + parseInt(lavatory_add);
			}
// console.log('[change] -> lavatory : ' + lavatory_shape + ' : ' + lavatory_id + ' : ' + lavatory_w + ' : ' + lavatory_h);
		}

		// Faucetがwallmount、2handle以外の場合のみ処理
		// （その２つはレバー一体の画像のため）
		if ( (faucet_shape != 'wallmount') && (faucet_shape != 'handle') && (faucet_series == 'ZL')) {

			// 設定値の取得
			var data = ENGINE.Simulator.settings['faucet_lever_pos'];

			var calc_lavatory_w_real = 0;
			var calc_lavatory_h_real = 0;

			// 品番指定がある場合
			if (data[lavatory_id]) {
// console.log('type [product_id]');
				calc_lavatory_w_real = data[lavatory_id]['w_pos'];
				calc_lavatory_h_real = data[lavatory_id]['h_pos'];

			// 品番指定がない場合、壁からの位置と
			} else {
				// underの場合
				if (lavatory_shape == 'under') {
					// inset
					if (lavatory_inset == 'inset') {
// console.log('under / inset');
						calc_lavatory_w_real = data['default'][lavatory_shape][lavatory_inset]['w_pos'];
						calc_lavatory_h_real = data['default'][lavatory_shape][lavatory_inset]['h_pos'];

					// outset
					} else {
// console.log('under / outset');
						// faucetがshortかどうかの判断
						if (faucet_category == 'short') {
// console.log(data['default'][lavatory_shape]);
// console.log(data['default'][lavatory_shape][faucet_category]);
							calc_lavatory_w_real = data['default'][lavatory_shape][lavatory_inset]['short']['w_pos'];
							calc_lavatory_h_real = data['default'][lavatory_shape][lavatory_inset]['short']['h_pos'];
						} else {
							calc_lavatory_w_real = data['default'][lavatory_shape][lavatory_inset]['default']['w_pos'];
							calc_lavatory_h_real = data['default'][lavatory_shape][lavatory_inset]['default']['h_pos'];
						}
					}
				} else {
// console.log('other');
// console.log('type [other]');
					calc_lavatory_w_real = data['default']['default'][lavatory_inset]['w_pos'];
					calc_lavatory_h_real = data['default']['default'][lavatory_inset]['h_pos'];

				}

				// lavatoryの幅、奥行き分を加算
				calc_lavatory_w_real = Number(calc_lavatory_w_real);
				calc_lavatory_h_real = Number(calc_lavatory_h_real);

// console.log('size [' + lavatory_h + ', ' + lavatory_w + ']');
// console.log('pos [' + calc_lavatory_h_real + ', ' + calc_lavatory_w_real + ']');

				calc_lavatory_h_real += Number(lavatory_h);
				calc_lavatory_w_real += Number(lavatory_w) / 2;

			}

// console.log('pos + size (mm) [' + calc_lavatory_w_real + ', ' + calc_lavatory_h_real + ']');

		  // 定数
		  // 縮尺率（固定）
		  // var _RATIO     = 0.785;
		  var _RATIO     = 0.785;
		  // 画像サイズ
		  var _BASE_SIZE = 1200;
		  // 基準点から先明記手前までの位置を取得する際の角度（基準点からみて）
		  var _RADIAN    = -0.17125;

			// 起点となる壁と（画像左上からの位置％）
			// var _BASE_POS_LEFT = 69.5;
			// var _BASE_POS_TOP  = 52;
			var _BASE_POS_LEFT = 68;
			var _BASE_POS_TOP  = 48;

			// 換算用の角度分回転させる
			var lavatory_x = Math.cos(_RADIAN) * calc_lavatory_h_real;
			var lavatory_y = Math.sin(_RADIAN) * calc_lavatory_h_real;
			lavatory_x = Math.abs(lavatory_x);
			lavatory_y = Math.abs(lavatory_y);

			// 縮尺調整
			var lavatory_pos_left = lavatory_x * _RATIO;
			var lavatory_pos_top  = lavatory_y * _RATIO;
			// ％に変換
			lavatory_pos_left = lavatory_pos_left / _BASE_SIZE;
			lavatory_pos_top  = lavatory_pos_top / _BASE_SIZE;
			// 端数調整
			lavatory_pos_left = Math.round(lavatory_pos_left * 10000) / 100;
			lavatory_pos_top  = Math.round(lavatory_pos_top * 10000) / 100;
			// 壁基準点をベースに洗面器位置（手前）を取得
			lavatory_pos_left = _BASE_POS_LEFT - lavatory_pos_left;
			lavatory_pos_top  = _BASE_POS_TOP + lavatory_pos_top;


		  // 洗面器手前位置からレバー設置位置の角度
		  var _RADIAN_LEVER = -2.109;
		  // var _RATIO_LEVER  = 0.785;
		  var _RATIO_LEVER  = 0.6;

			// 換算用の角度分回転させる
			var lever_x = Math.cos(_RADIAN_LEVER) * calc_lavatory_w_real;
			var lever_y = Math.sin(_RADIAN_LEVER) * calc_lavatory_w_real;
			lever_x = Math.abs(lever_x);
			lever_y = Math.abs(lever_y);

			// 縮尺調整
			var lever_pos_left = lever_x * _RATIO_LEVER;
			var lever_pos_top  = lever_y * _RATIO_LEVER;
			// ％に変換
			lever_pos_left = lever_pos_left / _BASE_SIZE;
			lever_pos_top  = lever_pos_top / _BASE_SIZE;
			// 端数調整
			lever_pos_left = Math.round(lever_pos_left * 10000) / 100;
			lever_pos_top  = Math.round(lever_pos_top * 10000) / 100;

			// 洗面器位置（手前）をベースに、レバー位置を取得
			lever_pos_left = lavatory_pos_left + lever_pos_left;
			lever_pos_top  = lavatory_pos_top + lever_pos_top;

// TOPからの位置
// console.log('left topからの位置');
// console.log(lever_pos_left, lever_pos_top);
// TOPからの位置
// console.log('壁基準位置');
// console.log(_BASE_POS_LEFT, _BASE_POS_TOP);

			pos = {
				'pos_left': lever_pos_left,
				'pos_top': lever_pos_top
			};
		}

// console.log('getFaucetLeverPosition() - END');

		return pos;
	},
	/**
	 * Faucetがwallmoutの場合の位置調整
	 *
	 */
	getFaucetPosition(faucet_shape, faucet_series, lavatory_shape, lavatory_id, lavatory_d) {
		var pos = 0;

// console.log('getFaucetPosition() - START.');
// console.log('faucet : ' + faucet_shape + ' : ' + faucet_series);
// console.log('lavatory : ' + lavatory_shape + ' : ' + lavatory_id + ' : ' + lavatory_d);
// console.log(ENGINE.Simulator.settings['faucet_wallmount_pos']);

		// FaucetのShapeがwallmountかどうか
		// ※wallmount以外は位置調整なし
		if (faucet_shape == 'wallmount') {

			// 洗面器の溢れ面の位置を取得 ※単位はmm
			// 設定値の取得
			var data = ENGINE.Simulator.settings['faucet_wallmount_pos'];
			var counter_diff = 0;

			// 指定品番の洗面器かどうか（selfrimming, semi-reccesedの場合、洗面器の溢れ面からの位置がわからないため）
			if (data[lavatory_id]) {
				// faucetのSeriesがZLかどうか（設定ファイルで定義）で設置位置が決定
				if (data[lavatory_id][faucet_series]) {
					counter_diff = data[lavatory_id][faucet_series];
				} else {
					counter_diff = data[lavatory_id]['default'];
				}
			// 指定品番以外の場合
			} else {
				// faucetのSeriesがZLかどうか（設定ファイルで定義）で溢れ面からの位置を取得
				if (data['default'][faucet_series]) {
					counter_diff = data['default'][faucet_series];
				} else {
					counter_diff = data['default']['default'];
				}
				// LavatoryのShapeがunder以外の場合、洗面器の高さをプラスする
				if (lavatory_shape != 'under') {
					counter_diff += parseInt(lavatory_d, 10);
// console.log('lavatory_d : ' + lavatory_d);
// console.log('counter_diff : ' + counter_diff);
				}
			}

			// 換算値の算出 (px)
			// var pos_px = counter_diff * 1.4860861;
			// var pos_px = counter_diff * 1.4860861;
			var pos_px = counter_diff * 1.4860861;
			pos_px -= 130;

			// 換算値の算出 (%)
			var pos_rate = pos_px / 2400;

			pos = Math.round(pos_rate * 100) / 100;
// console.log('pos(mm) : ' + counter_diff);
// console.log('pos(px) : ' + pos_px);
// console.log('pos(%) : ' + pos_rate);
// console.log('pos(%) : ' + pos);
		}

// console.log('getFaucetPosition() - END [' + pos + ']');

		return pos;
	},
	//////////////////////////////////////////////////////////////////
	// [END] 製品検索系の処理（シミュレータ固有）
	//////////////////////////////////////////////////////////////////

	/**
	 * 結果表示用URLパラメータの生成
	 *
	 */
	generateURLParameter(data) {

		data = data?data:ENGINE.Simulator.condition;

		var param = [];

		var selected_faucet        = data['faucet-product'];
		var selected_faucet_colour = data['faucet-colour'];
		var selected_lavatory     = data['lavatory-product'];

		// Lavagoryの場合品番に#が使用されているものがあるためファイル名変換を行う
		selected_lavatory = ENGINE.Simulator.converProductID2URL(selected_lavatory);
		// console.log('generateURLParameter() : ' + selected_lavatory);

		if (selected_faucet) {
			param.push('fid=' + selected_faucet);
		}
		if (selected_faucet_colour) {
			param.push('fc=' + selected_faucet_colour);
		}
		if (selected_lavatory) {
			param.push('lid=' + selected_lavatory);
		}

		var qstr = '';
		if (param.length > 0) {
			qstr = '?' + param.join('&');
		}

		return qstr;
	},

	/**
	 * Lavagoryの場合品番に#が使用されているものがあるためファイル名変換を行う
	 *
	 */
	converProductID2URL: function(product_id, is_reverse) {
		var result = product_id + '';
		if (is_reverse) {
			result = result.replace('-', '#');
		} else {
			result = result.replace('#', '-');
		}

		return result;
	},

};




window.addEventListener('DOMContentLoaded', function() {
	ENGINE.Simulator.init();
});
